import VirtualScroller from "/WebInterface/new-ui/modules/virtualscroll.js";
import Dropdown from "/WebInterface/new-ui/modules/dropdown/dropdown.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";
import C from "/WebInterface/new-ui/assets/js/utils/log.js";
import {
  uploadFileCardTemplate,
  uploadFileButtonContainerTemplate,
  globalFileCardTemplate,
} from "/WebInterface/new-ui/upload/js/template.js";
import store from "/WebInterface/new-ui/upload/js/reducer.js";
import setLocale from "/WebInterface/new-ui/upload/js/localization.js";
import { doFilesExists } from "/WebInterface/new-ui/upload/utils/apis.js";
import { UploadFileCardTemplateTexts } from "/WebInterface/new-ui/upload/utils/constants.js";
import { t } from "/WebInterface/new-ui/modules/localizations/localizations.js";
import uploadingQueue from "/WebInterface/new-ui/upload/js/uploading-queue.js";
import { batchComplete } from "/WebInterface/new-ui/assets/js/utils/api/apis.js";
import Loader from "/WebInterface/new-ui/modules/loader/loader.js";
import { Confirm } from "/WebInterface/new-ui/modules/alert.js";
import { apiCall } from "/WebInterface/new-ui/assets/js/utils/api/apis.js";

// TODO: refactor these methods "next, prev, onNext, onPrev", using same logic twice

let virtualScrollerList;
const maxFilesAllowedInQueue = invoke("getUserCustomizationValue", [
  "maxFilesInQueue",
  true,
]);
let isMaxFileErrorActive = false;
let uploadTypeRanges = null;
let queueCompleted = false;
let globalUploadTimeUpdateInterval = null; // Interval for updating global progress bar time

const getTransferType = (fileSize) => {
  if (uploadTypeRanges) {
    const uploadType = utils.getTransferTypeForFileUsingRange(
      uploadTypeRanges,
      fileSize
    );
    return uploadType;
  }

  const uploadTypeCustomization = invoke("getUserCustomizationValue", [
    "uploadTypeCustomization",
    true,
  ]);

  uploadTypeRanges = utils.getFileTransferTypesRanges(uploadTypeCustomization);
  if (!uploadTypeRanges) {
    return null;
  }

  const uploadType = utils.getTransferTypeForFileUsingRange(
    uploadTypeRanges,
    fileSize
  );
  return uploadType;
};

const convertFilesObjectToList = (fileObj) => {
  const filesArray = Array.from(fileObj || []);
  const manipulatedArray = filesArray.map((file) => {
    return { file };
  });
  return manipulatedArray;
};

// To invoke parent methods
function invoke(method, params) {
  const _parent =
    typeof self.window[method] === "function" ? self.window : parent.window;
  if (_parent[method]) {
    return _parent[method].apply(this, params);
  }
}

function getUploadContextPath() {
  const fromHost = invoke("currentPath");
  if (fromHost !== undefined && fromHost !== null && String(fromHost) !== "") {
    return String(fromHost);
  }
  try {
    if (window.parent && window.parent !== window) {
      const pv = parent.window.__crushdropUploadPath;
      if (typeof pv === "string" && pv.trim() !== "") {
        return pv.trim();
      }
    }
  } catch (e) {}
  let attr = "";
  try {
    if (window.parent && window.parent !== window) {
      attr =
        parent.document.documentElement.getAttribute(
          "data-crushdrop-upload-path"
        ) || "";
    }
  } catch (e) {
    attr = "";
  }
  if (attr.trim() === "") {
    try {
      attr =
        document.documentElement.getAttribute("data-crushdrop-upload-path") ||
        "";
    } catch (e) {
      attr = "";
    }
  }
  if (attr.trim() !== "") return attr.trim();
  if (
    typeof window.__crushdropUploadPath === "string" &&
    window.__crushdropUploadPath.trim() !== ""
  ) {
    return window.__crushdropUploadPath.trim();
  }
  return "/";
}

function applyCrushdropPathOnStandaloneDocument(p) {
  if (typeof p !== "string") return;
  const t = p.trim().replace(/\/+/g, "/");
  const next = t.startsWith("/") ? t : "/" + t;
  window.__crushdropUploadPath = next;
  document.documentElement.setAttribute("data-crushdrop-upload-path", next);
}

function syncCrushdropPathFromMessageOrEvent(pathStr) {
  if (typeof pathStr !== "string") return;
  const setter = invoke("setCrushdropUploadPath");
  if (typeof setter === "function") {
    setter(pathStr);
  } else {
    applyCrushdropPathOnStandaloneDocument(pathStr);
  }
}

const getUploadItemIcon = (file) => {
  if (file.isDir) {
    if (!utils.hasAlternateWebInterfaceImagesPath()) {
      return '<img src="/WebInterface/new-ui/assets/images/folder.png" alt="folder-img" class="media-image"/>';
    }
    return utils.getWebInterfaceImageTag("folder.png", {
      alt: "folder-img",
      class: "media-image",
    });
  }

  const fileExtension = utils.isImageExtension(file);
  const iconPath = fileExtension || "file";

  if (!utils.hasAlternateWebInterfaceImagesPath()) {
    return `<img src="/WebInterface/new-ui/assets/images/file-extension-icons/${iconPath}-extension.png" alt="${iconPath}-img" />`;
  }

  return utils.getWebInterfaceImageTag(
    `file-extension-icons/${iconPath}-extension.png`,
    {
      alt: `${iconPath}-img`,
    }
  );
};

const getListingError = (error = {}) => {
  if (Object.keys(error).length === 0) return false;
  return (
    error.maxFiles ||
    error.fileTypeNotAllowed ||
    error.zeroByteFileNotAllowed ||
    error.fileExistInListing ||
    error.fileExistOnServer
  );
};

const getUploadCompletionMessage = (file) => {
  const { time, status, size } = file;

  if (status !== "done") {
    return false;
  }

  const timeInSec = time / 1000;
  const timeTaken =
    timeInSec < 1
      ? `${timeInSec.toFixed(1)} secs`
      : utils.formatTime({
          secs: timeInSec,
          minLabel: "m",
          secondsLabel: "s",
        });

  const averageSpeed = size / timeInSec;
  const averageUploadingSpeed = utils.formatBytes(averageSpeed);

  return {
    timeTaken,
    averageUploadingSpeed: `${averageUploadingSpeed}/s`,
    message: t("uploadedInSecAtAnAverageSpeed", {
      time: timeTaken,
      speed: `${averageUploadingSpeed}/s`,
    }),
  };
};

const getProgressBarStatus = (file) => {
  const { status, uploadedBytes = 0, size } = file;

  let progressBarStatus = {};

  const updatedValue = parseInt(uploadedBytes);

  progressBarStatus.uploadedBytesFormatted = utils.formatBytes(updatedValue);
  progressBarStatus.uploadedBytes = updatedValue;
  progressBarStatus.completedPercentage = `${Math.floor(
    Math.min((updatedValue / size) * 100, 99)
  )} %`;

  if (
    status === "uploading" ||
    status === "paused" ||
    status === "pausing" ||
    status === "canceling" ||
    status === "finalizing"
  ) {
    progressBarStatus.showProgressBar = true;
  }

  return progressBarStatus;
};

const getUploadTimeStatus = (file) => {
  const { speed, elapsedTime, timeRemaining, overAllSpeed } = file;

  const uploadingSpeed = utils.formatBytes(speed);
  const _elapsedTime = utils.formatTime({
    secs: elapsedTime,
    minLabel: "m",
    secondsLabel: "s",
  });
  const _timeRemaining =
    timeRemaining &&
    Number.isFinite(timeRemaining) &&
    timeRemaining !== "-" &&
    timeRemaining > 0
      ? utils.formatTime({
          secs: timeRemaining,
          minLabel: "m",
          secondsLabel: "s",
        })
      : "-";
  const _overAllSpeed = utils.formatBytes(
    Number.isFinite(overAllSpeed) ? overAllSpeed : 0
  );

  return {
    speed: `${uploadingSpeed}/s`,
    elapsedTime: _elapsedTime,
    timeRemaining: `${_timeRemaining}`,
    overAllSpeed: `${_overAllSpeed || 0}/s`,
  };
};

const getUploadingError = (status, uploadingError) => {
  let error = "";
  switch (status) {
    case "canceled":
      error = t("canceled");
      break;

    case "failed":
      error = uploadingError || t("failed");
      break;

    default:
      break;
  }

  return error;
};

const totalFileStatus = {
  setSelectedFiles: ({
    totalCheckedFiles,
    totalCheckedFilesSize,
    shouldHide,
  }) => {
    const totalSelectedFilesEl = _$("#totalSelectedFiles");
    const totalSelectedFilesSizeEl = _$("#totalSelectedFilesSize");
    const uploadSelectedInfoEl = _$("#uploadSelectedInfo");

    if (shouldHide) {
      totalSelectedFilesEl.text(0);
      totalSelectedFilesSizeEl.text(utils.formatBytes(0));
      totalSelectedFilesSizeEl.attr("bytes", 0);
      uploadSelectedInfoEl.addClass("is-hidden");
    } else {
      totalSelectedFilesEl.text(totalCheckedFiles);
      totalSelectedFilesSizeEl.text(utils.formatBytes(totalCheckedFilesSize));
      totalSelectedFilesSizeEl.attr("bytes", totalCheckedFilesSize);

      if (totalCheckedFiles > 0) {
        uploadSelectedInfoEl.removeClass("is-hidden");
      } else {
        _$("#checkAll").el().checked = false;
        uploadSelectedInfoEl.addClass("is-hidden");
      }
    }
  },

  getTotalSelectedFiles: () => {
    return parseInt(_$("#totalSelectedFiles").text());
  },

  getTotalSelectedFilesSize: () => {
    return parseInt(_$("#totalSelectedFilesSize").attr("bytes"));
  },

  setTotalFilesFailed: (increment) => {
    const totalFailedFilesEl = _$("#totalFailedFiles");
    const failedFilesInfoEl = _$("#failedFilesInfo");
    const totalFiles = parseInt(totalFailedFilesEl.text()) || 0;

    const totalFilesFailedCount = _$(
      "#failedFilesInfo span[data-i18n-key='totalNoFilesFailed']"
    );
    totalFilesFailedCount.text(
      t("totalNoFilesFailed", { count: totalFiles + 1 })
    );
    totalFilesFailedCount.attr(
      "data-i18n-opt",
      `{ "count": ${totalFiles + 1} }`
    );

    if (totalFiles + increment < 1) {
      totalFailedFilesEl.text(0);
      failedFilesInfoEl.addClass("is-hidden");
    } else {
      totalFailedFilesEl.text(totalFiles + increment);
      failedFilesInfoEl.removeClass("is-hidden");
    }
  },
};

const getButtonsToShowOnFileCard = (status) => {
  const hideStartButtonOnIndividualUploadItem = invoke(
    "getUserCustomizationValue",
    ["hideStartButtonOnIndividualUploadItem"]
  );

  const showResume = invoke("getUserCustomizationValue", ["showResume", true]);
  let enableShowResume = true;
  if (
    showResume !== null &&
    showResume !== undefined &&
    showResume === "false"
  ) {
    enableShowResume = false;
  }
  const selectedToResumeUploadByDefault = invoke("getUserCustomizationValue", [
    "ResumeUploadSelectedByDefault",
    true,
  ]);
  const showOverWriteButton = selectedToResumeUploadByDefault
    ? selectedToResumeUploadByDefault === "false"
    : true;

  const cardButtons = {
    fileSizeExceeded: {
      overWriteButton: !enableShowResume ? true : showOverWriteButton,
      resumeButton: enableShowResume,
      removeButton: true,
    },
    listingError: {
      overWriteButton: !enableShowResume ? true : showOverWriteButton,
      resumeButton: enableShowResume,
      removeButton: true,
    },
    restrictionError: {
      removeButton: true,
    },
    fileSizeExceededInit: {
      removeButton: true,
    },
    init: {
      uploadButton: !hideStartButtonOnIndividualUploadItem,
      removeButton: true,
    },
    queued: {
      cancelButton: true,
      waitingButton: true,
    },
    uploading: {
      pauseButton: true,
      cancelButton: true,
    },
    done: {
      reUploadButton: true,
      removeButton: true,
    },
    paused: {
      resumePauseButton: true,
      cancelButton: true,
    },
    canceled: {
      reUploadButton: true,
      removeButton: true,
    },
    failed: {
      reUploadButton: true,
      removeButton: true,
    },
    canceling: {
      cancelingButton: true,
    },
    finalizing: {
      finalizingButton: true,
    },
    pausing: {
      pausingButton: true,
      cancelButton: true,
    },
    fileTypeNotAllowed: {
      removeButton: true,
    },
    zeroByteFileNotAllowed: {
      removeButton: true,
    },
  };

  return cardButtons[status] || {};
};

const removeFileFromQueue = (file) => {
  if (file.status === "uploading" || file.status === "paused") return;

  if (file.status === "queued") {
    uploadingQueue.removeFileFromUploadingQueue(file);
  }

  store.dispatch("removeFileFromUploadFileListing", file);
  uploadingQueue.removeFileFromCompletedQueue(file);
  return true;
};

const normalizeUploadPath = (path) => {
  if (!path || typeof path !== "string") return "";
  let next = path;
  try {
    next = utils.decodeURILocal(path);
  } catch (e) {}
  next = String(next).replace(/\\/g, "/").replace(/\/+/g, "/");
  if (!next.startsWith("/")) next = `/${next}`;
  return next;
};

const uploadPathWasDeleted = (nameF, deletedPaths) => {
  const target =
    normalizeUploadPath(nameF).replace(/\/+$/, "").toLowerCase() || "/";
  return deletedPaths.some((deleted) => {
    const raw = normalizeUploadPath(deleted);
    if (!raw) return false;
    const isDir = raw.length > 1 && raw.endsWith("/");
    const base = raw.replace(/\/+$/, "").toLowerCase() || "/";
    if (isDir) {
      return target === base || target.startsWith(`${base}/`);
    }
    return target === base;
  });
};

const listingMatchRemoved = (file, deletedPaths) => {
  const curTreeItems = invoke("getCurrentTreeItems");
  const uploadFileName = String(file.nameF || file.name || "")
    .split("/")
    .filter((part) => part)
    .pop();
  if (!uploadFileName) return uploadPathWasDeleted(file.nameF, deletedPaths);

  const matches = Array.isArray(curTreeItems)
    ? curTreeItems.filter((item) => {
        return (
          item?.name &&
          item.name.trim().toLowerCase() === uploadFileName.trim().toLowerCase()
        );
      })
    : [];

  if (matches.length === 0) {
    return uploadPathWasDeleted(file.nameF, deletedPaths);
  }

  return matches.every((item) => {
    const itemPath =
      item.href_path || `${item.root_dir || ""}${item.name || ""}`;
    return uploadPathWasDeleted(itemPath, deletedPaths);
  });
};

const clearServerExistsAfterDelete = (deletedPaths) => {
  if (!Array.isArray(deletedPaths) || deletedPaths.length === 0) return;

  const stayed = {};
  const moved = {};
  let changed = false;
  Object.values(store.fileList).forEach((file) => {
    const serverConflictCleared =
      file?.listingError?.fileExistOnServer &&
      (file.status === "listingError" || file.status === "fileSizeExceeded") &&
      listingMatchRemoved(file, deletedPaths);

    if (!serverConflictCleared) {
      stayed[file.id] = file;
      return;
    }

    changed = true;

    if (file.status === "fileSizeExceeded") {
      stayed[file.id] = {
        ...file,
        listingError: {
          fileExistInListing: "Storage Quota Exceeded.",
        },
        status: "fileSizeExceededInit",
      };
      return;
    }

    moved[file.id] = {
      ...file,
      listingError: {},
      status: "init",
      skipAutoStart: true,
    };
  });

  if (!changed) return;

  store.dispatch("addFileToUploadFileListAndRefresh", {
    ...stayed,
    ...moved,
  });
};

const overwriteFileInQueue = (file) => {
  const { id } = file;

  const curFile = store.fileList[id];

  let files = {};

  if (curFile.status === "fileSizeExceeded") {
    files[id] = {
      ...curFile,
      listingError: {
        fileExistInListing: "Storage Quota Exceeded.",
      },
      status: "fileSizeExceededInit",
    };
  } else files[id] = { ...curFile, listingError: {}, status: "init" };

  store.dispatch("updateFileStatusAndRerenderFile", files);
};

const resumeFileInQueue = (file) => {
  const { id } = file;

  const curFile = store.fileList[id];

  let files = {};
  if (curFile.status === "fileSizeExceeded") {
    files[id] = {
      ...curFile,
      listingError: {
        fileExistInListing: "Storage Quota Exceeded.",
      },
      status: "fileSizeExceededInit",
    };
  } else {
    files[id] = { ...curFile, listingError: {}, resumed: true, status: "init" };
  }

  store.dispatch("updateFileStatusAndRerenderFile", files);
};

// validate uploading file
const validateFile = (file, error, isFileSizeExceeded) => {
  let listingError = {};

  const fileExistOnServer = (name, _path) => {
    if (!name || !_path) return false;
    name = name.toLowerCase();

    // Get current directory path
    let currentPath = getUploadContextPath();

    currentPath = currentPath || "/";

    // Normalize directory paths to ensure consistent comparison
    // Ensure directory paths end with / and don't have double slashes
    const normalizeDirPath = (path) => {
      if (!path) return "/";
      // Remove trailing slashes, then add one back
      path = path.replace(/\/+$/, "") || "/";
      return path === "" ? "/" : path + "/";
    };

    // Extract directory from the upload destination path
    // _path is the full destination path (e.g., "/a/1.txt" or "/1.txt")
    const uploadPathParts = _path.split("/").filter((p) => p);
    const uploadDir =
      uploadPathParts.length > 1
        ? "/" + uploadPathParts.slice(0, -1).join("/") + "/"
        : "/";
    const uploadFileName =
      uploadPathParts.length > 0
        ? uploadPathParts[uploadPathParts.length - 1]
        : name;

    const currentDirNormalized = normalizeDirPath(currentPath);
    const uploadDirNormalized = normalizeDirPath(uploadDir);

    // Only check if we're viewing the same directory as the upload destination
    // If uploading to a different directory, we can't check with currentTreeItems
    // (which only returns files in the current directory)
    if (uploadDirNormalized !== currentDirNormalized) {
      return false; // Can't check - we're not viewing that directory
    }

    // We're viewing the correct directory, check if file exists
    let fileAvl = false;
    let curTreeItems = invoke("getCurrentTreeItems");

    if (curTreeItems) {
      fileAvl = curTreeItems.some((item) => {
        // Compare filename (case-insensitive)
        return (
          item.name.trim().toLowerCase() === uploadFileName.trim().toLowerCase()
        );
        // || item_name.trim().toLowerCase() === name.trim() + "" + tempExtension
      });
    }

    return fileAvl;
  };

  const { name, nameF } = file;

  const isFileExistOnServer = error || fileExistOnServer(name, nameF);

  if (isFileExistOnServer) {
    listingError.fileExistOnServer =
      "File with the same name is available on the server.";

    if (isFileSizeExceeded)
      listingError.fileExistOnServer += " Storage Quota Exceeded.";
  }

  return listingError;
};

const handleCustomCommonFileUploadFormOnFileAdd = (actualFileList) => {
  const uploadFileList = Object.values(actualFileList);

  const onCancel = (uploadFormModal) => {
    const cancelConfirm = window.confirm(
      t("areYouSureYouWishToCancelUploadForLastSelectedItems", {
        length: uploadFileList.length,
      })
    );

    uploadFileList.forEach((f) => {
      removeFileFromQueue(f);
    });

    if (cancelConfirm) uploadFormModal.hide(true);
  };

  const onSuccess = (formData) => {
    store.dispatch("setCustomCommonUploadFormValues", formData);

    const isCustomUploadFormAvailable = invoke("isCustomUploadFormAvailable");
    if (isCustomUploadFormAvailable) {
      handleCustomFileUploadFormOnFileAdd(actualFileList);
    } else {
      handleUpdateUploadFileListing();
    }
  };

  const formValues = store?.customCommonUploadFormValues;
  invoke("showCommonUploadForm", [{ formValues, onCancel, onSuccess }]);
};

const handleCustomFileUploadFormOnFileAdd = (fileList) => {
  const uploadFileList = Object.values(fileList).filter(
    (f) =>
      f.status !== "fileSizeExceeded" && f.status !== "fileSizeExceededInit"
  );

  let index = 0;
  let file = uploadFileList[index];

  if (!file) return;

  const next = () => {
    if (index >= uploadFileList.length - 1) return;
    index++;
    const uploadFile = uploadFileList[index];
    return uploadFile;
  };

  const prev = () => {
    if (index < 1) return;
    index--;
    const uploadFile = uploadFileList[index];
    return uploadFile;
  };

  const onSuccess = (
    uploadFormModal,
    uploadFormDetails,
    doNotShowRemainingFiles
  ) => {
    const validateFields = invoke("validate", [uploadFormModal.root, false]);

    if (validateFields.length === 0) {
      const data = utils.formatFormDatesForApi(
        uploadFormModal.root,
        utils.serializeInputs(uploadFormModal.root)
      );

      const customFormData = {
        ...data,
        meta_form_name: uploadFormDetails?.name,
        meta_UploadFormId: uploadFormDetails?.id,
        meta_UploadFormName: uploadFormDetails?.name,
        meta_unique_upload_id: file?.id,
      };

      store.dispatch("updateFileStatus", {
        [file.id]: {
          ...file,
          customFormData,
        },
      });

      file = next();

      if (doNotShowRemainingFiles) {
        while (file) {
          store.dispatch("updateFileStatus", {
            [file.id]: {
              ...file,
              customFormData,
            },
          });
          file = next();
        }

        handleUpdateUploadFileListing();
        uploadFormModal.hide(true);
        return;
      }

      if (file) {
        const customFormData = store.fileList[file.id].customFormData;
        invoke("updateCustomUploadFormModal", [
          uploadFormModal,
          file,
          customFormData,
        ]);
        return;
      }

      handleUpdateUploadFileListing();
      uploadFormModal.hide(true);
    }
  };

  const onCancel = (uploadFormModal) => {
    uploadFileList.forEach((f) => {
      if (!store?.fileList[f.id]?.customFormData) removeFileFromQueue(f);
    });
    handleUpdateUploadFileListing();
    uploadFormModal.hide(true);
  };

  const onPrev = ({ uploadFormModal }) => {
    const prevFile = prev();

    if (prevFile) {
      const data = utils.formatFormDatesForApi(
        uploadFormModal.root,
        utils.serializeInputs(uploadFormModal.root)
      );

      store.dispatch("updateFileStatus", {
        [file.id]: {
          ...file,
          customFormData: {
            ...data,
          },
        },
      });

      file = prevFile;
      const customFormData = store.fileList[file.id].customFormData;

      invoke("updateCustomUploadFormModal", [
        uploadFormModal,
        file,
        customFormData,
      ]);
      return;
    }
  };

  const onNext = ({ uploadFormModal }) => {
    const nextFile = next();

    if (nextFile) {
      const data = utils.formatFormDatesForApi(
        uploadFormModal.root,
        utils.serializeInputs(uploadFormModal.root)
      );

      store.dispatch("updateFileStatus", {
        [file.id]: {
          ...file,
          customFormData: {
            ...data,
          },
        },
      });

      file = nextFile;
      const customFormData = store.fileList[file.id].customFormData;

      invoke("updateCustomUploadFormModal", [
        uploadFormModal,
        file,
        customFormData,
      ]);
      return;
    }
  };

  invoke("showCustomUploadFormModal", [
    {
      onSuccess,
      onCancel,
      onPrev,
      onNext,
      uploadFile: file,
    },
  ]);
};

const handleCustomFileUploadFormOnClickDetails = (_file) => {
  const uploadFileList = Object.values(store.fileList);

  let index = uploadFileList.findIndex((f) => f.id === _file.id);
  if (index < 0) index = 0;

  let file = uploadFileList[index];

  const next = () => {
    if (index >= uploadFileList.length - 1) return;
    index++;
    const uploadFile = uploadFileList[index];
    return uploadFile;
  };

  const prev = () => {
    if (index < 1) return;
    index--;
    const uploadFile = uploadFileList[index];
    return uploadFile;
  };

  const onSuccess = (uploadFormModal, uploadFormDetails) => {
    const validateFields = invoke("validate", [uploadFormModal.root, false]);

    if (validateFields.length === 0) {
      const data = utils.formatFormDatesForApi(
        uploadFormModal.root,
        utils.serializeInputs(uploadFormModal.root)
      );

      store.dispatch("updateFileStatus", {
        [file.id]: {
          ...file,
          customFormData: {
            ...file.customFormData,
            ...data,
            meta_form_name: uploadFormDetails?.name,
            meta_UploadFormId: uploadFormDetails?.id,
            meta_UploadFormName: uploadFormDetails?.name,
            meta_unique_upload_id: file?.id,
          },
        },
      });

      uploadFormModal.hide(true);
    }
  };

  const onCancel = (uploadFormModal) => {
    uploadFormModal.hide(true);
  };

  const onPrev = ({ uploadFormModal }) => {
    const prevFile = prev();

    if (prevFile) {
      const data = utils.formatFormDatesForApi(
        uploadFormModal.root,
        utils.serializeInputs(uploadFormModal.root)
      );

      store.dispatch("updateFileStatus", {
        [file.id]: {
          ...file,
          customFormData: {
            ...data,
          },
        },
      });

      file = prevFile;
      const customFormData = store.fileList[file.id].customFormData;

      invoke("updateCustomUploadFormModal", [
        uploadFormModal,
        file,
        customFormData,
      ]);
      return;
    }
  };

  const onNext = ({ uploadFormModal }) => {
    const nextFile = next();

    if (nextFile) {
      const data = utils.formatFormDatesForApi(
        uploadFormModal.root,
        utils.serializeInputs(uploadFormModal.root)
      );

      store.dispatch("updateFileStatus", {
        [file.id]: {
          ...file,
          customFormData: {
            ...data,
          },
        },
      });

      file = nextFile;
      const customFormData = store.fileList[file.id].customFormData;

      invoke("updateCustomUploadFormModal", [
        uploadFormModal,
        file,
        customFormData,
      ]);
      return;
    }
  };

  const onAfterShow = ({ uploadFormModal }) => {
    const customFormData = store.fileList[file.id].customFormData;
    invoke("updateCustomForm", [customFormData, uploadFormModal]);
  };

  invoke("showCustomUploadFormModal", [
    {
      onAfterShow,
      onSuccess,
      onCancel,
      onPrev,
      onNext,
      uploadFile: file,
    },
  ]);
};

// rename file
const renameFile = (name, fullPath) => {
  const segments = [];
  const pushPath = (value) => {
    String(value || "")
      .replace(/\\/g, "/")
      .split("/")
      .forEach((part) => {
        if (part) segments.push(part);
      });
  };
  pushPath(getUploadContextPath() || "/");
  pushPath(fullPath || "/");
  const fileName = String(name || "")
    .replace(/\\/g, "/")
    .replace(/^\/+|\/+$/g, "");
  if (fileName) segments.push(fileName);
  return `/${segments.join("/")}`;
};

const addFilesToQueue = async (fileList = []) => {
  const checkAllCheckboxChecked = _$("#checkAll").el().checked;

  const maxUploadItemsWarningMessage = invoke("getUserCustomizationValue", [
    "maxUploadItemsWarningMessage",
    true,
  ]);
  const maxUploadItemsBeforeShowingWarning = invoke(
    "getUserCustomizationValue",
    ["maxUploadItemsBeforeShowingWarning", true]
  );

  if (parseInt(maxUploadItemsBeforeShowingWarning) < fileList.length) {
    invoke("growl", [
      maxUploadItemsWarningMessage || t("largeUploadListingDefaultWarning"),
      t("warning"),
      null,
      true,
    ]);
  }

  const liveUploadStatuses = new Set([
    "init",
    "queued",
    "uploading",
    "paused",
    "pausing",
    "canceling",
    "finalizing",
    "listingError",
    "fileSizeExceeded",
    "fileSizeExceededInit",
  ]);
  const finishedUploadStatuses = new Set(["done", "canceled", "failed"]);
  const pathsInBatch = new Set();
  const skippedNames = [];
  const activeQueueIds = new Set(
    uploadingQueue
      .getQueue()
      .map((queuedFile) => queuedFile?.id)
      .filter(Boolean)
  );
  const destinationPath = (file, fullPath) =>
    window?.init_href_path
      ? `${window.init_href_path}/${file.name}`
      : renameFile(file.name, fullPath || "/");

  const confirmPaths = [];
  const seenConfirmPaths = new Set();
  fileList.forEach((fileObj) => {
    const file = fileObj?.file;
    if (!file || file.isDir || !file.name) return;

    const nameF = destinationPath(file, fileObj?.fullPath);
    if (seenConfirmPaths.has(nameF)) return;

    const matchingRows = Object.values(store.fileList).filter(
      (existing) => existing?.nameF === nameF
    );
    if (!matchingRows.length) return;

    const blocked = matchingRows.some(
      (existing) =>
        liveUploadStatuses.has(existing.status) ||
        activeQueueIds.has(existing.id)
    );
    if (blocked) return;

    const finished = matchingRows.some(
      (existing) =>
        finishedUploadStatuses.has(existing.status) &&
        !activeQueueIds.has(existing.id)
    );
    if (!finished) return;

    seenConfirmPaths.add(nameF);
    confirmPaths.push({ nameF, name: file.name });
  });

  const acceptedFreshPaths = new Set();
  const declinedFreshPaths = new Set();
  let applyRest = null;

  for (let index = 0; index < confirmPaths.length; index++) {
    const item = confirmPaths[index];
    if (applyRest === true) {
      acceptedFreshPaths.add(item.nameF);
      continue;
    }
    if (applyRest === false) {
      declinedFreshPaths.add(item.nameF);
      continue;
    }

    const total = confirmPaths.length;
    const message =
      total > 1
        ? t("freshUploadAlreadyInListCount", {
            name: item.name,
            current: index + 1,
            total,
          })
        : t("freshUploadAlreadyInList", { name: item.name });

    let applyInput = null;
    let append = null;
    if (total > 1) {
      applyInput = _$("<input>").addClass("checkbox").el();
      applyInput.type = "checkbox";
      applyInput.name = "applyToAll";
      const applyLabel = _$("<label>")
        .addClass("is-flex")
        .addClass("is-align-items-center")
        .addClass("gap-3")
        .addClass("mt-3")
        .addClass("is-cursor-pointer")
        .el();
      const applyText = _$("<span>").text(t("applyToAllFiles")).el();
      applyLabel.appendChild(applyInput);
      applyLabel.appendChild(applyText);
      append = applyLabel;
    }

    let noAppliesToAll = false;
    const resp = await Confirm({
      title: `<span data-i18n-key="fileAlreadyInUploadList">${t(
        "fileAlreadyInUploadList"
      )}</span>`,
      body: `<span data-i18n-key="${
        total > 1
          ? "freshUploadAlreadyInListCount"
          : "freshUploadAlreadyInList"
      }">${message}</span>`,
      append,
      closable: true,
      confirm: `<span data-i18n-key="yes">${t("yes")}</span>`,
      cancel: {
        label: `<span data-i18n-key="no">${t("no")}</span>`,
        onClick: () => {
          noAppliesToAll = !!applyInput?.checked;
        },
      },
    });

    if (resp) {
      acceptedFreshPaths.add(item.nameF);
      if (resp.applyToAll) applyRest = true;
    } else {
      declinedFreshPaths.add(item.nameF);
      if (noAppliesToAll) applyRest = false;
    }
  }

  let actualFileList = {};

  fileList.forEach((fileObj) => {
    const file = fileObj?.file;
    const fullPath = fileObj?.fullPath || "/";
    const error = fileObj?.exists;

    const extension = utils.getFileExtension(file);

    const { isDir } = file;
    let nameF = destinationPath(file, fullPath);
    if (isDir && nameF && !nameF.endsWith("/")) nameF = `${nameF}/`;

    if (!isDir && file.name) {
      const matchingRows = Object.values(store.fileList).filter(
        (existing) => existing?.nameF === nameF
      );
      const hasLiveRow =
        pathsInBatch.has(nameF) ||
        matchingRows.some(
          (existing) =>
            liveUploadStatuses.has(existing.status) ||
            activeQueueIds.has(existing.id)
        );

      if (hasLiveRow) {
        skippedNames.push(file.name);
        return;
      }

      if (declinedFreshPaths.has(nameF)) {
        return;
      }

      const finishedRows = matchingRows.filter(
        (existing) =>
          finishedUploadStatuses.has(existing.status) &&
          !activeQueueIds.has(existing.id)
      );

      if (finishedRows.length > 0 && !acceptedFreshPaths.has(nameF)) {
        return;
      }

      finishedRows.forEach((existing) => {
        uploadingQueue.removeFileFromCompletedQueue(existing);
        delete store.fileList[existing.id];
      });

      pathsInBatch.add(nameF);
    }

    const size = file.size;
    const sizeF = utils.formatBytes(size);

    const lastModifiedF = utils.formatDateForListing(file.lastModified, "");

    const id = utils.getUId();

    const canUseWebSocketForUploading = invoke("getUserCustomizationValue", [
      "useWSForAdvancedUploads",
    ]);

    const uploadTypeByRangeCustomization = getTransferType(size);
    const uploadTypeBySimpleCustomization = canUseWebSocketForUploading
      ? "WS"
      : "Normal";

    const obj = {
      id,
      isDir,
      file,
      nameF,
      sizeF,
      lastModifiedF,
      name: file.name,
      lastModified: file.lastModified,
      lastModifiedDate: file.lastModifiedDate,
      type: file.type,
      size: size,
      uploadType:
        uploadTypeByRangeCustomization || uploadTypeBySimpleCustomization,
      speed: 0,
      elapsedTime: 0,
      checked: checkAllCheckboxChecked,
    };

    const disableZeroByteUpload = invoke("getUserCustomizationValue", [
      "disableZeroByteUpload",
    ]);
    if (!isDir && disableZeroByteUpload && size <= 0) {
      actualFileList[id] = {
        ...obj,
        status: "zeroByteFileNotAllowed",
        listingError: { zeroByteFileNotAllowed: t("zeroByteFileNotAllowed") },
      };
      return;
    }

    const allowedExtensionsToUpload = invoke("getUserCustomizationValue", [
      "onlyAllowedExtensionsToUpload",
      true,
    ]);
    if (!isDir && allowedExtensionsToUpload) {
      const isExtensionAllow = allowedExtensionsToUpload
        .toLowerCase()
        .split(",")
        .some(
          (ext) => ext.trim() === extension || ext.trim() === `.${extension}`
        );

      if (!isExtensionAllow) {
        actualFileList[id] = {
          ...obj,
          status: "fileTypeNotAllowed",
          listingError: { fileTypeNotAllowed: t("fileTypeNotAllowed") },
        };
        return;
      }
    }

    const notAllowedExtensionsToUpload = invoke("getUserCustomizationValue", [
      "notAllowedExtensionsToUpload",
      true,
    ]);
    if (!isDir && notAllowedExtensionsToUpload) {
      const isExtensionNotAllow = notAllowedExtensionsToUpload
        .toLowerCase()
        .split(",")
        .some(
          (ext) => ext.trim() === extension || ext.trim() === `.${extension}`
        );

      if (isExtensionNotAllow) {
        actualFileList[id] = {
          ...obj,
          status: "fileTypeNotAllowed",
          listingError: { fileTypeNotAllowed: t("fileTypeNotAllowed") },
        };
        return;
      }
    }

    if (isDir) {
      actualFileList[id] = {
        ...obj,
        status: "init",
        listingError: {},
      };
      return;
    }

    const currentDirInfo = invoke("getCurrentDirInfo");
    const isFileSizeExceededFromQuota =
      parseInt(currentDirInfo?.quota_bytes) < size;
    const listingError = validateFile(obj, error, isFileSizeExceededFromQuota);
    actualFileList[id] = {
      ...obj,
      status: Object.keys(listingError).length > 0 ? "listingError" : "init",
      listingError,
    };

    if (isFileSizeExceededFromQuota && Object.keys(listingError).length > 0)
      actualFileList[id].status = "fileSizeExceeded";
    else if (isFileSizeExceededFromQuota) {
      actualFileList[id].status = "fileSizeExceededInit";
      actualFileList[id].listingError = {
        fileTypeNotAllowed: "Storage Quota Exceeded.",
      };
    }
  });

  if (skippedNames.length > 0) {
    const uniqueNames = [...new Set(skippedNames)];
    const names =
      uniqueNames.length === 1
        ? uniqueNames[0]
        : `${uniqueNames.length} files`;
    invoke("growl", [
      t("warning"),
      t("alreadyInTheUploadList", { names }),
      4000,
      true,
    ]);
  }

  store.dispatch("addFileToUploadFileList", { ...actualFileList });
  window.init_href_path = null;

  let actualFileListArray = Object.values(actualFileList);
  actualFileListArray = actualFileListArray.filter(
    (actualFile) =>
      actualFile.status !== "fileTypeNotAllowed" ||
      actualFile.status !== "zeroByteFileNotAllowed"
  );

  if (actualFileListArray.length > 0) {
    const actualFileListObject = actualFileListArray.reduce(
      (accumulator, currentValue) => ({
        ...accumulator,
        [currentValue.id]: currentValue,
      }),
      {}
    );

    const commonUploadForm = invoke("commonUploadForm");

    const commonFormPerBatch =
      invoke("getUserCustomizationValue", ["commonFormPerBatch"]) &&
      queueCompleted;

    if (
      commonUploadForm?.formDetails &&
      (commonFormPerBatch || !store?.customCommonUploadFormValues)
    ) {
      queueCompleted = false;
      handleCustomCommonFileUploadFormOnFileAdd(actualFileListObject);
      return;
    }

    const isCustomUploadFormAvailable = invoke("isCustomUploadFormAvailable");
    if (isCustomUploadFormAvailable)
      handleCustomFileUploadFormOnFileAdd(actualFileListObject);
  }
};

const getSharingFiles = (getSelected = false) => {
  const fileList = Object.values(store.fileList);
  const filesToShare = [];

  fileList.forEach((file) => {
    if (file.status === "done") {
      if (getSelected) {
        if (file.checked) filesToShare.push(file.nameF);
        return;
      }

      filesToShare.push(file.nameF);
    }
  });

  const files =
    filesToShare.length > 5
      ? filesToShare.slice(0, 5).join("\r\n") +
        `\r\n(and ${filesToShare.length - 5} more...)`
      : filesToShare.join("\r\n");

  const paths = filesToShare.join("\r\n");
  const filesLength = filesToShare.length;

  return { files, paths, filesLength };
};

// Upload modal header buttons events
const uploadHeaderButtonsEvents = () => {
  const clearFilter = () => {
    const fileList = Object.values(store.fileList);
    let allFiles = {};

    _$("#search").val("");
    const checkAllCheckbox = _$("#checkAll").el();
    checkAllCheckbox.checked = false;

    fileList.forEach((file) => {
      delete file.hide;
      allFiles[file.id] = { ...file, checked: false };
    });

    _$("#filter-applied-button,#filteredText").addClass("is-hidden");

    store.dispatch("updateFileStatusInFileList", allFiles);
    handleUpdateUploadFileListing();
  };

  _$("#addFilesButtonUploadModal").on("click", () => {
    _$("#fileInputUploadModal").el().click();
  });

  _$("#uploadFileButton").on("click", () => {
    _$("#fileInputUploadModal").el().click();
  });

  _$("#uploadAllButtonUploadModal").on("click", () => {
    if (isMaxFileErrorActive) return;
    const fileList = Object.values(store.fileList);
    const filteredFiles = fileList.filter(
      (file) => file.status === "init" && !file.hide
    );
    filteredFiles.forEach((file) => {
      uploadingQueue.addFileToUploadingQueue(file);
    });

    if (filteredFiles?.length > 0) {
      const parentPostUploadConfig = {
        type: "uploadStarted",
        mode: "all-files",
        files: filteredFiles.map((file) => ({
          name: file.name,
          uploading_to: file.nameF,
          size: file.size,
          status: "",
        })),
      };

      invoke("uploadNotifications", [parentPostUploadConfig]);
    }
  });

  _$("#reUploadAllButtonUploadModal").on("click", async () => {
    if (isMaxFileErrorActive) return;

    const resp = await Confirm({
      title: `<span data-i18n-key="reUploadAll">${t("reUploadAll")}</span>`,
      body: `<span data-i18n-key="reuploadConfirmationMessage">${t(
        "reuploadConfirmationMessage"
      )}</span>`,
      closable: true,
      confirm: `<span data-i18n-key="yes">${t("yes")}</span>`,
      cancel: `<span data-i18n-key="no">${t("no")}</span>`,
    });

    if (!resp) {
      return;
    }

    const fileList = Object.values(store.fileList);
    const filteredFiles = fileList.filter(
      (file) => file.status === "done" || file.status === "canceled"
    );

    filteredFiles.forEach((file) => {
      uploadingQueue.addFileToUploadingQueue(file);
    });

    if (filteredFiles?.length > 0) {
      const parentPostUploadConfig = {
        type: "uploadStarted",
        mode: "all-files",
        files: filteredFiles.map((file) => ({
          name: file.name,
          uploading_to: file.nameF,
          size: file.size,
          status: "",
        })),
      };

      invoke("uploadNotifications", [parentPostUploadConfig]);
    }
  });

  _$("#uploadSelectedButtonUploadModal").on("click", () => {
    if (isMaxFileErrorActive) return;
    const fileList = Object.values(store.fileList);
    const filteredFiles = fileList.filter(
      (file) => file.status === "init" && file.checked
    );

    filteredFiles.forEach((file) => {
      uploadingQueue.addFileToUploadingQueue(file);
    });

    if (filteredFiles?.length > 0) {
      const parentPostUploadConfig = {
        type: "uploadStarted",
        mode: "selected-files",
        files: filteredFiles.map((file) => ({
          name: file.name,
          uploading_to: file.nameF,
          size: file.size,
          status: "",
        })),
      };

      invoke("uploadNotifications", [parentPostUploadConfig]);
    }
  });

  _$("#cancelUploadingButtonUploadModal").on("click", () => {
    if (uploadingQueue.queue.length < 1) return;

    const canceled = window.confirm(t("areYouSureYouWantToCancelUploading"));

    if (canceled) {
      uploadingQueue.cancel(true);
    }
  });

  _$("#commonUploadFormButton").on("click", () => {
    const formValues = store?.customCommonUploadFormValues;

    const onSuccess = (formData) => {
      store.dispatch("setCustomCommonUploadFormValues", formData);
    };

    invoke("showCommonUploadForm", [
      {
        formValues,
        onSuccess,
        onCancel: (uploadFormModal) => {
          uploadFormModal?.hide(true);
        },
      },
    ]);
  });

  _$("#overwriteAllButtonUploadModal").on("click", () => {
    if (isMaxFileErrorActive) return;

    const fileList = Object.values(store.fileList);
    let updatedFiles = {};

    fileList.forEach((file) => {
      if (file.status === "fileSizeExceeded") {
        updatedFiles[file.id] = {
          ...file,
          listingError: {
            fileExistInListing: "Storage Quota Exceeded.",
          },
          status: "fileSizeExceededInit",
        };
      }
      if (file.status === "listingError") {
        updatedFiles[file.id] = { ...file, status: "init", listingError: {} };
      }
    });
    store.dispatch("updateFileStatusAndRerenderFile", updatedFiles);
  });

  _$("#resumeAllButtonUploadModal").on("click", () => {
    if (isMaxFileErrorActive) return;

    const fileList = Object.values(store.fileList);
    let updatedFiles = {};

    fileList.forEach((file) => {
      if (file.status === "fileSizeExceeded") {
        updatedFiles[file.id] = {
          ...file,
          listingError: {
            fileExistInListing: "Storage Quota Exceeded.",
          },
          status: "fileSizeExceededInit",
        };
      }
      if (file.status === "listingError") {
        updatedFiles[file.id] = {
          ...file,
          resume: true,
          status: "init",
          listingError: {},
        };
      }
    });
    store.dispatch("updateFileStatusAndRerenderFile", updatedFiles);
  });

  _$("#checkAll").on("click", (e) => {
    const fileList = Object.values(store.fileList);
    let updatedFiles = {};

    let totalCheckedFilesSize = 0;
    let totalCheckedFiles = 0;

    fileList.forEach((file) => {
      if (file.hide) return;

      const card = _$(`#${file.id}`);
      if (card.el()) {
        card.find(".checkbox", true).checked = e.target.checked;
      }

      totalCheckedFiles++;
      totalCheckedFilesSize = totalCheckedFilesSize + file.size;
      updatedFiles[file.id] = { ...file, checked: e.target.checked };
    });

    totalFileStatus.setSelectedFiles({
      totalCheckedFiles,
      totalCheckedFilesSize,
      shouldHide: totalCheckedFilesSize && e.target.checked ? false : true,
    });

    store.dispatch("updateFileStatusInFileList", updatedFiles);
  });

  const removeFiles = (status) => {
    store.dispatch("removeMultipleFilesFromUploadFileListing", { status });
  };

  _$("#removeAllSelectedButtonUploadModal").on("click", () => {
    removeFiles("checked");
  });

  _$("#removeAllWithErrorButtonUploadModal").on("click", () => {
    if (isMaxFileErrorActive) {
      removeFiles();
      return;
    }
    removeFiles("listingError");
    removeFiles("fileSizeExceeded");
    removeFiles("fileSizeExceededInit");
    removeFiles("zeroByteFileNotAllowed");
  });

  _$("#removeAllUploadedButtonUploadModal").on("click", () => {
    removeFiles("done");
  });

  _$("#removeAllCanceledButtonUploadModal").on("click", () => {
    removeFiles("canceled");
  });

  _$("#removeAllSkippedButtonUploadModal").on("click", () => {
    removeFiles("skipped");
  });

  _$("#removeAllButtonUploadModal").on("click", () => {
    removeFiles();
  });

  _$("#shareUploadedButtonUploadModal").on("click", () => {
    const files = getSharingFiles();
    if (files.filesLength) invoke("initSharing", [files]);
  });

  _$("#shareSelectedButtonUploadModal").on("click", () => {
    const files = getSharingFiles(true);
    if (files.filesLength) invoke("initSharing", [files]);
  });

  _$("#filter-applied-button").on("click", () => {
    clearFilter();
  });

  _$("#search").on("input", (e) => {
    const { value } = e.target;

    if (!value) {
      clearFilter();
      return;
    }

    const fileList = Object.values(store.fileList);
    let filteredFiles = {};
    let allFiles = {};

    fileList.forEach((file) => {
      delete file.hide;

      let hide = true;

      if (file.nameF.toLowerCase().includes(value.toLowerCase())) {
        filteredFiles[file.id] = { ...file, checked: false };
        hide = false;
      }

      allFiles[file.id] = { ...file, checked: false, hide };
    });

    _$("#filter-applied-button,#filteredText").removeClass("is-hidden");
    const checkAllCheckbox = _$("#checkAll").el();
    checkAllCheckbox.checked = false;

    store.dispatch("updateFileStatusInFileList", allFiles);
    handleUpdateUploadFileListing();
  });
};

// upload modal hidden file input event
_$("#fileInputUploadModal").on("change", (e) => {
  if (uploadingQueue.queue.length > 0 && isMaxFileErrorActive) {
    invoke("growl", [
      t("maxNumberOfFilesExceeded"),
      t("maxFileAllowedTouploadExceeded", { maxFilesAllowedInQueue }),
      4000,
      true,
    ]);
    return;
  }

  const fileObj = e.target.files;
  const filesToUpload = convertFilesObjectToList(fileObj);
  addFilesToQueue(filesToUpload);

  //Remove file selection as its no longer required
  _$("#fileInputUploadModal").val("");
});

// Drag and drop file event
const uploadDragAndDropEvents = () => {
  let isDraggingCrushFTPItem = false;

  window.addEventListener("dragstart", () => {
    isDraggingCrushFTPItem = true;
  });

  window.addEventListener("dragend", (e) => {
    e.preventDefault();
    isDraggingCrushFTPItem = false;
  });

  window.addEventListener("dragover", () => {
    if (isDraggingCrushFTPItem) {
      return;
    }

    if (!invoke("getDraggingItemIsFromCrushFTP"))
      _$("#uploadDragAndDropSection").removeClass("is-hidden");
  });

  _$("#uploadDragAndDropSection").on("dragleave", () => {
    _$("#uploadDragAndDropSection").addClass("is-hidden");
  });

  window.addEventListener("drop", () => {
    _$("#uploadDragAndDropSection").addClass("is-hidden");
  });

  _$("#uploadDragAndDropSection").on("drop", async (e) => {
    if (isDraggingCrushFTPItem) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();

    const privs = invoke("currentDirPrivs");
    if (!privs?.includes("(write)")) {
      invoke("growl", [
        t("youDoNotHavePermissionToUpload"),
        t("uploadNotAllowed"),
        5000,
        true,
      ]);
      _$("#uploadDragAndDropSection").addClass("is-hidden");
      return false;
    }

    const dataTransfer = e.dataTransfer;
    if (!dataTransfer) {
      _$("#uploadDragAndDropSection").addClass("is-hidden");
      return false;
    }

    let filesObj = {};
    const finalFilesArray = [];

    const handleDnDUpload = (dataTransfer, callback) => {
      if (uploadingQueue.queue.length > 0 && isMaxFileErrorActive) {
        invoke("growl", [
          t("maxNumberOfFilesExceeded"),
          t("maxFileAllowedTouploadExceeded", { maxFilesAllowedInQueue }),
          4000,
          true,
        ]);
        callback();
        return;
      }

      const fileItems = dataTransfer.items;
      const dataTransferFiles = dataTransfer.files;

      let pendingOperations = 0;
      let hasError = false;
      let sawUnsupportedNonFileDrag = false;
      let sawDirectory = false;
      let finishScheduled = false;

      const addDroppedFile = (file, directoryFullPath = "/") => {
        if (!file || !file.name) return;
        let fullPath = String(directoryFullPath || "/").replace(/\\/g, "/");
        if (!fullPath.startsWith("/")) fullPath = `/${fullPath}`;
        fullPath = fullPath.replace(/\/+/g, "/");
        const key = renameFile(file.name, fullPath);
        filesObj[key] = {
          file,
          fullPath,
          key,
        };
      };

      const addDroppedDirectory = (directoryFullPath) => {
        let fullPath = String(directoryFullPath || "").replace(/\\/g, "/");
        if (!fullPath.startsWith("/")) fullPath = `/${fullPath}`;
        fullPath = fullPath.replace(/\/+/g, "/").replace(/\/+$/, "");
        const name = fullPath.split("/").filter(Boolean).pop();
        if (!name) return;
        const parentSlice = fullPath.slice(0, fullPath.length - name.length);
        const parent = parentSlice.replace(/\/+$/, "") || "/";
        let key = renameFile(name, parent);
        if (!key.endsWith("/")) key += "/";
        filesObj[key] = {
          file: {
            name,
            size: 0,
            isDir: true,
            type: "",
          },
          fullPath: parent,
          key,
        };
      };

      const tryScheduleFinish = () => {
        if (pendingOperations !== 0 || hasError || finishScheduled) {
          return;
        }
        finishScheduled = true;

        if (
          !sawDirectory &&
          Object.keys(filesObj).length === 0 &&
          dataTransferFiles &&
          dataTransferFiles.length > 0
        ) {
          for (let i = 0; i < dataTransferFiles.length; i++) {
            const file = dataTransferFiles[i];
            if (file) {
              addDroppedFile(file);
            }
          }
        }

        if (sawUnsupportedNonFileDrag && Object.keys(filesObj).length === 0) {
          invoke("growl", [
            t("dragDropContentNotSupported"),
            t("warning"),
            4000,
            true,
          ]);
        }

        callback();
      };

      const processComplete = () => {
        pendingOperations--;
        if (pendingOperations < 0) {
          pendingOperations = 0;
        }
        if (pendingOperations === 0 && !hasError) {
          tryScheduleFinish();
        }
      };

      const joinDirectoryPath = (parent, name) => {
        const base = String(parent || "/")
          .replace(/\\/g, "/")
          .replace(/\/+$/, "");
        const child = String(name || "")
          .replace(/\\/g, "/")
          .replace(/^\/+|\/+$/g, "");
        if (!child) {
          if (!base || base === "/") return "/";
          return base.startsWith("/") ? base : `/${base}`;
        }
        const prefix = !base || base === "/" ? "" : base;
        return `${prefix}/${child}`.replace(/\/+/g, "/");
      };

      const readDirectoryEntry = (entry) => {
        pendingOperations++;
        const dirReader = entry.createReader();
        let _entries = [];

        const toArray = (list) => Array.prototype.slice.call(list || [], 0);

        const readEntries = () => {
          dirReader.readEntries(
            (results) => {
              if (!results.length) {
                if (_entries.length === 0) {
                  addDroppedDirectory(entry.fullPath || `/${entry.name || ""}`);
                }
                _entries.forEach((_entry) => {
                  if (_entry.isFile) {
                    pendingOperations++;
                    _entry.file(
                      (file) => {
                        addDroppedFile(file, entry.fullPath || "/");
                        processComplete();
                      },
                      () => {
                        hasError = true;
                        processComplete();
                      }
                    );
                  } else {
                    readDirectoryEntry(_entry);
                  }
                });
                processComplete();
                return;
              }
              _entries = _entries.concat(toArray(results));
              readEntries();
            },
            () => {
              hasError = true;
              processComplete();
            }
          );
        };

        readEntries();
      };

      const walkDirectoryHandle = (dirHandle, parentRelative) => {
        pendingOperations++;
        const here = joinDirectoryPath(parentRelative, dirHandle.name);
        const sequence = (async () => {
          let sawChild = false;
          const takeChild = async (child) => {
            if (!child) return;
            sawChild = true;
            if (child.kind === "directory") {
              walkDirectoryHandle(child, here);
              return;
            }
            if (child.kind === "file") {
              pendingOperations++;
              try {
                const file = await child.getFile();
                addDroppedFile(file, here);
              } catch (e) {}
              processComplete();
            }
          };

          if (typeof dirHandle.values === "function") {
            for await (const child of dirHandle.values()) {
              await takeChild(child);
            }
          } else if (typeof dirHandle.entries === "function") {
            for await (const pair of dirHandle.entries()) {
              const child = pair && pair.length ? pair[1] : pair;
              await takeChild(child);
            }
          }

          if (!sawChild) addDroppedDirectory(here);
        })();

        sequence.then(
          () => {
            processComplete();
          },
          () => {
            hasError = true;
            processComplete();
          }
        );
      };

      const queueFileItem = (item, entry, handle) => {
        pendingOperations++;
        const succeed = (file) => {
          addDroppedFile(file, "/");
          processComplete();
        };
        const fail = () => {
          hasError = true;
          processComplete();
        };
        if (entry && entry.isFile && typeof entry.file === "function") {
          entry.file(succeed, fail);
          return;
        }
        if (handle && typeof handle.getFile === "function") {
          handle.getFile().then(succeed, fail);
          return;
        }
        const file =
          typeof item.getAsFile === "function" ? item.getAsFile() : null;
        if (file) addDroppedFile(file, "/");
        processComplete();
      };

      const captures = [];
      if (fileItems && fileItems.length > 0) {
        for (let i = 0; i < fileItems.length; i++) {
          const item = fileItems[i];
          let entry = null;
          if (typeof item.webkitGetAsEntry === "function") {
            try {
              entry = item.webkitGetAsEntry();
            } catch (e) {
              entry = null;
            }
          }
          let handlePromise = null;
          const useFileSystemHandle =
            typeof window !== "undefined" &&
            window.isSecureContext &&
            !entry?.isDirectory &&
            typeof item.getAsFileSystemHandle === "function";
          if (useFileSystemHandle) {
            try {
              handlePromise = item.getAsFileSystemHandle();
            } catch (e) {
              handlePromise = null;
            }
          }
          captures.push({ item, entry, handlePromise });
        }
      }

      if (captures.length === 0) {
        tryScheduleFinish();
        return;
      }

      pendingOperations++;
      Promise.all(
        captures.map(async (cap) => {
          let handle = null;
          if (cap.handlePromise && typeof cap.handlePromise.then === "function") {
            try {
              handle = await cap.handlePromise;
            } catch (e) {
              handle = null;
            }
          }
          return { ...cap, handle };
        })
      )
        .then((resolved) => {
          resolved.forEach(({ item, entry, handle }) => {
            const blockDirectoryDrop = () => {
              sawDirectory = true;
              const blockDirectory = invoke("getUserCustomizationValue", [
                "blockUploadingDirs",
              ]);
              if (!blockDirectory) return false;
              invoke("growl", [
                t("directoriesCantBeUploadedSelectOnlyFiles"),
                t("uploadingDirectoryIsNotAllowed"),
                4000,
                true,
              ]);
              return true;
            };

            if (entry?.isDirectory) {
              if (blockDirectoryDrop()) return;
              readDirectoryEntry(entry);
              return;
            }

            if (handle?.kind === "directory") {
              if (blockDirectoryDrop()) return;
              walkDirectoryHandle(handle, "/");
              return;
            }

            if ((entry && entry.isFile) || handle?.kind === "file") {
              queueFileItem(item, entry, handle);
              return;
            }

            if (!entry && !handle && item.kind === "file") {
              const file =
                typeof item.getAsFile === "function" ? item.getAsFile() : null;
              if (file) addDroppedFile(file, "/");
              return;
            }

            if (item.kind === "string") {
              sawUnsupportedNonFileDrag = true;
            }
          });
          processComplete();
        })
        .catch(() => {
          hasError = true;
          processComplete();
        });
    };

    const checkFileExistsOnServer = async () => {
      const fileArr = Object.values(filesObj);
      const paths = [];
      const directoryItems = [];

      fileArr.forEach((item) => {
        if (item.file?.isDir) {
          directoryItems.push(item);
          return;
        }
        paths.push(utils.encodeURILocal(item.key));
      });

      const queueDirectories = () => {
        directoryItems.forEach(({ file, fullPath }) => {
          finalFilesArray.push({ file, fullPath, exists: false });
        });
      };

      if (paths.length < 1) {
        queueDirectories();
        addFilesToQueue(finalFilesArray);
        return;
      }

      try {
        const resp = await doFilesExists({
          paths: paths.join(";"),
          random: Math.random(),
        });

        const responseArr = utils.decodeURILocal(resp).split("\n");

        queueDirectories();
        responseArr.forEach(function (item) {
          const curItem = item.replace(/\n|\r/g, "").split(":");
          const exists = curItem[1] === "true";
          let path = curItem[0];

          if (filesObj[path]) {
            const { file, fullPath } = filesObj[path];
            finalFilesArray.push({ file, fullPath, exists });
          }
          delete filesObj[path];
        });
        addFilesToQueue(finalFilesArray);
      } catch (error) {
        C.error(error);
      }
    };

    const loading = new Loader({
      parentElement: _$("#uploadFileSection").el().parentElement.parentElement,
    });

    const filesDroppedAndAdded = () => {
      checkFileExistsOnServer();
      setTimeout(() => {
        loading.deleteLoader();
      }, 100);
    };
    let droppedAllTimer;
    handleDnDUpload(dataTransfer, () => {
      if (droppedAllTimer) clearInterval(droppedAllTimer);
      droppedAllTimer = setTimeout(filesDroppedAndAdded, 500);
    });

    _$("#uploadDragAndDropSection").addClass("is-hidden");
  });

  _$("#uploadDragAndDropSection").on("dragover", (e) => {
    e.preventDefault();
  });
};

// Upload File Card Button Listeners
const uploadFileCardButtonsListeners = (file, card) => {
  const addButtonListener = (selector, callback) => {
    const button = _$(card).find(selector);
    button?.on("click", (e) => callback(file, e.altKey));
  };

  addButtonListener(".upload-file-card-icon-wrapper", (file, altKey) => {
    if (altKey) {
      uploadingQueue.toggleUploadType(file);
      return;
    }
    return false;
  });

  addButtonListener("#upload-button", (file, altKey) => {
    if (altKey) {
      uploadingQueue.toggleUploadType(file);
      return;
    }
    uploadingQueue.addFileToUploadingQueue(file);

    const parentPostUploadConfig = {
      type: "uploadStarted",
      mode: "selected-files",
      files: [
        {
          name: file.name,
          uploading_to: file.nameF,
          size: file.size,
          status: "",
        },
      ],
    };
    invoke("uploadNotifications", [parentPostUploadConfig]);
  });

  addButtonListener("#remove-button", (file) => {
    removeFileFromQueue(file);
  });

  addButtonListener("#overwrite-button", (file) => {
    overwriteFileInQueue(file);
  });

  addButtonListener("#detail-button", async (file) => {
    handleCustomFileUploadFormOnClickDetails(file);
  });

  addButtonListener("#resume-button", (file) => {
    resumeFileInQueue(file);
  });

  addButtonListener("#resume-pause-button", () => {
    uploadingQueue.resume();
  });

  addButtonListener("#pause-button", () => {
    uploadingQueue.pausing();
  });

  addButtonListener("#reupload-button", (file, altKey) => {
    const reUploadId = utils.getUId();
    uploadingQueue.removeFileFromCompletedQueue(file);

    if (altKey) {
      uploadingQueue.toggleUploadType({ ...file, reUploadId });
      return;
    }
    uploadingQueue.addFileToUploadingQueue({ ...file, reUploadId });
  });

  addButtonListener("#cancel-button", (file) => {
    const canceled = window.confirm(
      t("areYouSureYouWantToCancelParticularFileFromUploading", {
        file: file.nameF,
      })
    );

    if (!canceled) {
      return;
    }

    const curUploadingFile = uploadingQueue.getCurrentUploadingFile();

    if (file?.id && curUploadingFile?.id === file?.id) {
      uploadingQueue.cancel();
    } else {
      uploadingQueue.removeFileFromUploadingQueue(file);

      store.dispatch("updateFileStatusAndRerenderFile", {
        [file?.id]: {
          ...file,
          status: "canceled",
        },
      });
    }
  });

  const checkbox = _$(card).find(".checkbox");
  checkbox.on("click", (e) => {
    const isChecked = e.target.checked;
    store.dispatch("updateFileStatusInFileList", {
      [file.id]: { ...file, checked: isChecked },
    });

    const files = store.fileList;
    let allFilesChecked = true;
    let allFilesUnChecked = true;
    let totalCheckedFiles = 0;
    let totalCheckedFilesSize = 0;

    Object.values(files).forEach((file) => {
      if (!file.checked && _$(`#${file.id}`).el()) allFilesChecked = false;
      if (file.checked) allFilesUnChecked = false;

      if (file.checked) {
        totalCheckedFiles++;
        totalCheckedFilesSize += file.size;
      }
    });

    _$("#checkAll").el().checked = allFilesChecked;

    if (allFilesUnChecked) {
      totalFileStatus.setSelectedFiles({ shouldHide: true });
    } else {
      totalFileStatus.setSelectedFiles({
        totalCheckedFiles,
        totalCheckedFilesSize,
        shouldHide: false,
      });
    }
  });
};

const checkMaxFilesReached = () => {
  const fileList = Object.values(store.fileList);
  let maxFileError = {};

  if (
    maxFilesAllowedInQueue &&
    fileList.length > maxFilesAllowedInQueue &&
    !isMaxFileErrorActive
  ) {
    isMaxFileErrorActive = true;

    invoke("growl", [
      t("maxNumberOfFilesExceeded"),
      t("maxFileAllowedTouploadExceeded", { maxFilesAllowedInQueue }),
      4000,
      true,
    ]);
  }

  if (maxFilesAllowedInQueue && fileList.length <= maxFilesAllowedInQueue) {
    isMaxFileErrorActive = false;
  }

  if (maxFilesAllowedInQueue && fileList.length > maxFilesAllowedInQueue) {
    maxFileError.status = "restrictionError";
    maxFileError.listingError = `Maximum files allowed in a queue ${maxFilesAllowedInQueue}`;
  }

  return maxFileError;
};

const getFileList = (fileObj = {}) => {
  const fileList = Object.values(fileObj);

  let totalSize = 0;
  let totalCheckedFiles = 0;
  let totalCheckedFilesSize = 0;

  const filteredList = fileList.filter((file) => {
    if (file.hide) return false;

    totalSize += file.size;

    if (file.checked) {
      totalCheckedFiles++;
      totalCheckedFilesSize += file.size;
    }

    return true;
  });

  _$("#totalFiles").text(filteredList.length);
  _$("#totalSize").text(utils.formatBytes(totalSize));

  totalFileStatus.setSelectedFiles({
    totalCheckedFiles,
    totalCheckedFilesSize,
    shouldHide: totalCheckedFiles > 0 ? false : true,
  });

  return filteredList;
};

const reCheckFileQuota = () => {
  const fileArr = Object.values(store.fileList);
  let actualFileList = store.fileList;

  store.dispatch("addFileToUploadFileListAndRefresh", {});

  const currentDirInfo = invoke("getCurrentDirInfo");
  const quotaBytesLeft = parseInt(currentDirInfo?.quota_bytes);

  fileArr.forEach((file) => {
    const id = file.id;

    const isFileSizeExceededFromQuota = quotaBytesLeft < file.size;
    if (isFileSizeExceededFromQuota) return;

    if (file.status === "fileSizeExceeded") {
      const listingError = validateFile(
        file,
        null,
        isFileSizeExceededFromQuota
      );

      actualFileList[id] = {
        ...file,
        status: Object.keys(listingError).length > 0 ? "listingError" : "init",
        listingError,
      };
    } else if (file.status === "fileSizeExceededInit") {
      actualFileList[id] = { ...file, listingError: {}, status: "init" };
    }
  });

  store.dispatch("addFileToUploadFileListAndRefresh", { ...actualFileList });
};

// Listing uploading files
const handleUpdateUploadFileListing = () => {
  const fileArr = Object.values(store.fileList);
  const uploadFilesSection = document.querySelector("#uploadFileSection");

  const fileList = getFileList(store.fileList);

  if (fileArr.length === 0) {
    uploadFilesSection.innerHTML = uploadFileButtonContainerTemplate({
      dragAndDropFileHereText: t("dragAndDropFileHere"),
      uploadFilesText: t("uploadFiles"),
    });
    _$("#uploadFileButton").on("click", () => {
      _$("#fileInputUploadModal").el().click();
    });
    return;
  }

  const maxFileError = checkMaxFilesReached();

  const scrollTopBeforeRerender =
    virtualScrollerList?.container?.scrollTop || 0;

  uploadFilesSection.innerHTML = "";

  virtualScrollerList.init({
    totalRows: fileList.length,
    generatorFn: (rowIndex) => {
      const { id } = fileList[rowIndex];

      const filesObj = store.fileList;
      const file = filesObj[id];

      let status = file?.status;

      const uploadFileCardWrapper = _$("<div>").el();
      uploadFileCardWrapper.id = id;
      uploadFileCardWrapper.classList.add("upload-file-card-wrapper");

      const autoStartFile = lookForAutoStartUpload(file, status);
      if (autoStartFile) {
        status = "queued";
      }

      const showCardButtons = getButtonsToShowOnFileCard(
        maxFileError.status || status
      );
      const listingError =
        maxFileError.listingError || getListingError(file.listingError);
      const uploadingError = maxFileError.status
        ? ""
        : getUploadingError(status, file.uploadingError);
      const completionDetails = maxFileError.status
        ? null
        : getUploadCompletionMessage(file);
      const progressBarStatus = maxFileError.status
        ? {}
        : getProgressBarStatus(file);

      const timeStatus = getUploadTimeStatus(file);
      const isElectronUploadOnlyApp = invoke("isElectron");

      uploadFileCardWrapper.insertAdjacentHTML(
        "beforeend",
        uploadFileCardTemplate({
          id: file.id,
          hideCheckbox: isElectronUploadOnlyApp,
          checked: file?.checked || false,
          image: getUploadItemIcon(file),
          name: file.nameF,
          sizeInBytes: file.file.size,
          size: file.sizeF,
          listingError,
          customFormData: file?.customFormData,
          lastModifiedF: file.lastModifiedF,
          chunkPreparationStalled: file?.chunkPreparationStalled,
          uploadType: file.uploadType,
          ...showCardButtons,
          ...progressBarStatus,
          ...timeStatus,
          uploadingError,
          completionMessage: completionDetails?.message,
          timeTaken: completionDetails?.timeTaken,
          averageUploadingSpeed: completionDetails?.averageUploadingSpeed,
          ...UploadFileCardTemplateTexts(),
        })
      );

      uploadFileCardButtonsListeners(file, uploadFileCardWrapper);

      return uploadFileCardWrapper;
    },
  });

  uploadFilesSection.append(virtualScrollerList.container);
  virtualScrollerList.container.scrollTop = scrollTopBeforeRerender;
};

const lookForAutoStartUpload = (file, status) => {
  const shouldStartFileUpload = invoke("checkForAutoUpload");

  if (!shouldStartFileUpload) {
    return;
  }

  const commonUploadForm = invoke("commonUploadForm");
  const isCustomUploadFormAvailable = invoke("isCustomUploadFormAvailable");

  if (commonUploadForm?.formDetails && !store?.customCommonUploadFormValues) {
    return;
  }

  if (isCustomUploadFormAvailable && !file.customFormData) {
    return;
  }

  if (file.skipAutoStart) {
    return;
  }

  if (status === "init") {
    uploadingQueue.addFileToUploadingQueue(file);
    return true;
  }
};

const shareFilesOnQueueFinishedElectron = async () => {
  const completedFiles = uploadingQueue.getCompletedFiles();
  const ipcRenderer = invoke("getIPCRenderer");

  const filesToShare = [];

  completedFiles.forEach((file) => {
    const fileData = store?.fileList[file.id];
    if (fileData?.status === "done") {
      return filesToShare.push(fileData?.nameF);
    }
  });

  const files = filesToShare.join("\r\n");

  const defaultEmailBody =
    "A user would like to share a file with you.  This link will expire on {date} at {time}\r\n\r\n{web_link}";
  const defaultEmailSubject = "Sharing: A new file is being shared with you.";
  const baseURL = invoke("getBaseURL");

  const obj = {
    command: "publish",
    allowUploads: false,
    attach: false,
    hide_download: false,
    baseUrl: utils.encodeURILocal(baseURL),
    emailBcc: "",
    emailReplyTo: "",
    emailBody: defaultEmailBody,
    share_comments: "",
    emailCc: "",
    emailFrom: "",
    emailSubject: defaultEmailSubject,
    emailTo: "",
    shareUsername: false,
    shareUsernames: "",
    logins: -1,
    shareUsernamePermissions: "",
    expire: utils.formatDateTimeForApi(new Date()),
    paths: files,
    publishType: "reference",
    sendEmail: false,
  };

  try {
    const response = await apiCall("publish", {
      ...obj,
    });

    const result = response?.commandResult?.response;

    const message = utils.decodeURILocal(result?.message);
    const url = utils.decodeURILocal(result?.url);

    const id = utils.getUId();
    const timestamp = Date.now();
    const time = utils.formatDateForListing(timestamp, "");
    const sharedItems = filesToShare;

    const shareData = {
      message,
      url,
      id,
      timestamp,
      time,
      sharedItems,
      sharedItemsPaths: files,
    };

    const userInfo = invoke("getUserInfo");
    const { username } = userInfo;
    const shareHistory =
      JSON.parse(localStorage.getItem(`${username}_share_history`)) || [];

    shareHistory.push(shareData);
    localStorage.setItem(
      `${username}_share_history`,
      JSON.stringify(shareHistory)
    );

    ipcRenderer.send("share-link", { url });
  } catch (error) {
    console.log(error);
  }
};

// File progress bar update subscribe events
const fileProgressStatus = {
  showUploadFileProgressBar: ({ fileId, size, resumeLoc = 0 }) => {
    const fileCard = _$(`#${fileId}`).el();
    if (fileCard) {
      _$(fileCard).find(".progress").attr("value", resumeLoc);
      _$(fileCard).find(".progress").attr("max", size);

      const maxValue = utils.formatBytes(size);
      _$(fileCard)
        .find(".upload-progress-status #fileSize")
        .text(`${maxValue}`);

      _$(fileCard).find(".progress-bar-container").removeClass("is-hidden");
    }
  },
  updateUploadFileProgressBar: ({ fileId, size, maxSize }) => {
    const fileCard = _$(`#${fileId}`).el();
    if (fileCard) {
      _$(fileCard).find(".progress").attr("value", size);
      _$(fileCard).find(".progress").attr("max", maxSize);

      const updatedValue = parseInt(size);

      const completedValue = utils.formatBytes(updatedValue);
      const maxValue = utils.formatBytes(maxSize);

      const percentage = Math.floor(Math.min((size / maxSize) * 100, 99));

      _$(fileCard).find("#completed-percentage").text(`${percentage} %`);

      _$(fileCard)
        .find(".upload-progress-status #fileSizeUploaded")
        .text(`${completedValue}`);

      _$(fileCard)
        .find(".upload-progress-status #fileSize")
        .text(`${maxValue}`);

      _$(fileCard).find(".upload-progress-status").removeClass("is-hidden");
      _$(fileCard).find(".progress-bar-container").removeClass("is-hidden");
    }
  },
  toggleChunkPreparationStalled: (action, payload) => {
    const { fileId, chunkPreparationStalled } = payload;
    console.log("toggleChunkPreparationStalled", {
      fileId,
      chunkPreparationStalled,
    });
    const fileCard = _$(`#${fileId}`).el();
    if (fileCard) {
      _$(fileCard)
        .find(".chunk-preparation-stalled")
        .toggleClass("is-hidden", !chunkPreparationStalled);
    }
  },
  updateFileTimeStatus: ({
    fileId,
    speed,
    elapsedTime,
    timeRemaining,
    overAllSpeed,
  }) => {
    const fileCard = _$(`#${fileId}`).el();
    if (!fileCard) return;

    const uploadingSpeed = utils.formatBytes(speed);
    const _elapsedTime = utils.formatTime({
      secs: elapsedTime,
      minLabel: "m",
      secondsLabel: "s",
    });
    const _timeRemaining =
      timeRemaining &&
      Number.isFinite(timeRemaining) &&
      timeRemaining !== "-" &&
      timeRemaining > 0
        ? utils.formatTime({
            secs: timeRemaining,
            minLabel: "m",
            secondsLabel: "s",
          })
        : "-";
    const _overAllSpeed = utils.formatBytes(
      Number.isFinite(overAllSpeed) ? overAllSpeed : 0
    );

    _$(fileCard)
      .find(".upload-progress-status #uploadingSpeed")
      .text(`${uploadingSpeed}/s`);

    _$(fileCard)
      .find(".upload-progress-status #elapsedTime")
      .text(`${_elapsedTime}`);

    _$(fileCard)
      .find(".upload-progress-status #remainingTime")
      .html(`${_timeRemaining}`);

    _$(fileCard)
      .find(".upload-progress-status #uploadingAverageSpeed")
      .html(`${_overAllSpeed || 0}/s`);

    _$(fileCard).find(".upload-progress-status").removeClass("is-hidden");
  },
};

const handleShowFileUploadStatus = (action, payload) => {
  fileProgressStatus.showUploadFileProgressBar(payload);
};

const handleUpdateFileUploadStatus = (action, payload) => {
  fileProgressStatus.updateUploadFileProgressBar(payload);
  updateGlobalProgressBar(payload.size);
};

// Sum upload time (seconds) from completed files plus the current file
const getTotalElapsedUploadTimeInSeconds = ({
  allUploadFiles = [],
  currentFile,
  globalStartTime,
}) => {
  const completedFilesTimeSeconds = allUploadFiles.reduce((total, file) => {
    if (!file || file.status !== "done") return total;

    const timeMs = Number(file.time || 0);
    if (Number.isFinite(timeMs) && timeMs > 0) {
      return total + timeMs / 1000;
    }

    const elapsedSeconds = Number(file.elapsedTime || 0);
    return Number.isFinite(elapsedSeconds) && elapsedSeconds > 0
      ? total + elapsedSeconds
      : total;
  }, 0);

  const currentElapsedSeconds = Number(currentFile?.elapsedTime || 0);
  let totalElapsedTime =
    completedFilesTimeSeconds +
    (Number.isFinite(currentElapsedSeconds) && currentElapsedSeconds > 0
      ? currentElapsedSeconds
      : 0);

  // Fallback to global start time if elapsed values are not yet available
  if (!totalElapsedTime && globalStartTime) {
    totalElapsedTime = (Date.now() - globalStartTime) / 1000;
  }

  return totalElapsedTime;
};

// Function to update global progress bar time (can be called by interval or events)
const updateGlobalProgressBarTime = () => {
  const currentUploadingFile = uploadingQueue.getCurrentUploadingFile();

  // Only update if global uploads section exists and is visible
  const globalUploadsEl = _$("#globalUploads").el();
  if (!globalUploadsEl || globalUploadsEl.classList.contains("is-hidden")) {
    return;
  }

  if (!currentUploadingFile) {
    return;
  }

  const curFile = store.fileList[currentUploadingFile.id];
  if (!curFile) {
    return;
  }

  const globalStartTime = uploadingQueue.getGlobalUploadStartTime();

  const allUploadFiles = Object.values(store.fileList).filter((file) => {
    if (file.hide) return false;
    const status = file.status;
    return (
      status === "init" ||
      status === "queued" ||
      status === "uploading" ||
      status === "paused" ||
      status === "pausing" ||
      status === "done" ||
      status === "canceled" ||
      status === "failed" ||
      status === "canceling" ||
      status === "finalizing" ||
      status === "fileSizeExceededInit"
    );
  });

  let totalBytesToUpload = 0;
  let bytesUploaded = curFile.uploadedBytes || 0;

  allUploadFiles.forEach((file) => {
    if (!file) return;
    totalBytesToUpload += file.size || 0;
  });

  allUploadFiles.forEach((file) => {
    if (file.status === "done") {
      bytesUploaded += file.size || 0;
    }
  });

  const totalElapsedTime = getTotalElapsedUploadTimeInSeconds({
    allUploadFiles,
    currentFile: curFile,
    globalStartTime,
  });

  const formattedElapsedTime = utils.formatTime({
    secs: totalElapsedTime,
    minLabel: "m",
    secondsLabel: "s",
  });

  // Calculate average speed from total bytes uploaded and elapsed time
  const averageSpeed =
    totalElapsedTime > 0 ? bytesUploaded / totalElapsedTime : 0;
  const formattedAverageSpeed = utils.formatBytes(
    Number.isFinite(averageSpeed) ? averageSpeed : 0
  );

  // Only show remaining time if we have a valid speed
  const remainingBytes = totalBytesToUpload - bytesUploaded;
  const timeRemaining =
    averageSpeed > 0 && Number.isFinite(averageSpeed)
      ? remainingBytes / averageSpeed
      : null;

  const formattedTimeRemaining =
    timeRemaining && Number.isFinite(timeRemaining) && timeRemaining > 0
      ? utils.formatTime({
          secs: timeRemaining,
          minLabel: "m",
          secondsLabel: "s",
        })
      : "-";

  const completedFilesCount = allUploadFiles.filter(
    (file) => file.status === "done"
  ).length;

  // Only update text content, don't recreate DOM (performance optimization)
  _$("#globalUploads #elapsedTime").text(formattedElapsedTime);
  _$("#globalUploads #uploadingAverageSpeed").text(
    `${formattedAverageSpeed}/s`
  );
  _$("#globalUploads #remainingTime").text(formattedTimeRemaining);

  // Also update the uploaded size display in the global progress bar
  const uploadedBytesFormatted = utils.formatBytes(bytesUploaded);
  _$("#globalUploads #fileSizeUploaded").text(uploadedBytesFormatted);

  const fileCountElement = _$("#globalUploads #global-upload-file-count");
  if (fileCountElement.el()) {
    fileCountElement.text(
      `${completedFilesCount + 1} of total ${allUploadFiles.length} item(s)`
    );
  }
};

const handleUpdateFileTimeStatus = (action, payload) => {
  fileProgressStatus.updateFileTimeStatus(payload);
  // Also update global progress bar time immediately
  updateGlobalProgressBarTime();
};

const handleUpdateFileStatusAndRerenderFile = (action, payload = {}) => {
  Object.values(payload).forEach((file) => {
    const { id, status } = file;

    if (!_$(`#${id}`).el()) return;

    if (status === "failed") {
      // totalFileStatus.setTotalFilesFailed(1);
    }

    store.dispatch("enableGlobalUpload");

    const showCardButtons = getButtonsToShowOnFileCard(status);
    const listingError = getListingError(file.listingError);
    const uploadingError = getUploadingError(status, file.uploadingError);
    const completionDetails = getUploadCompletionMessage(file);
    const progressBarStatus = getProgressBarStatus(file);
    const timeStatus = getUploadTimeStatus(file);

    const isElectronUploadOnlyApp = invoke("isElectron");

    _$(`#${id}`).html(
      uploadFileCardTemplate({
        id: file.id,
        hideCheckbox: isElectronUploadOnlyApp,
        checked: _$(`#${id}`).find(".checkbox", true)?.checked,
        image: getUploadItemIcon(file),
        name: file.nameF,
        sizeInBytes: file.file.size,
        size: file.sizeF,
        listingError,
        customFormData: file?.customFormData,
        lastModifiedF: file.lastModifiedF,
        uploadType: file?.uploadType,
        completionMessage: completionDetails?.message,
        timeTaken: completionDetails?.timeTaken,
        averageUploadingSpeed: completionDetails?.averageUploadingSpeed,
        uploadingError,
        finalizingMsg: file.finalizingMsg,
        ...showCardButtons,
        ...progressBarStatus,
        ...timeStatus,
        ...UploadFileCardTemplateTexts(),
      })
    );

    lookForAutoStartUpload(file, status);
    uploadFileCardButtonsListeners(file, _$(`#${id}`).el());
  });
};

// subscribe events
const subscribe = () => {
  const uploadFileActions = [
    {
      eventName: "addFileToUploadFileList",
      callback: handleUpdateUploadFileListing,
    },
    {
      eventName: "addFileToUploadFileListAndRefresh",
      callback: handleUpdateUploadFileListing,
    },
    { eventName: "showFileUploadStatus", callback: handleShowFileUploadStatus },
    {
      eventName: "updateFileUploadStatus",
      callback: handleUpdateFileUploadStatus,
    },
    { eventName: "updateFileTimeStatus", callback: handleUpdateFileTimeStatus },
    {
      eventName: "toggleChunkPreparationStalled",
      callback: fileProgressStatus.toggleChunkPreparationStalled,
    },
    {
      eventName: "updateFileStatusAndRerenderFile",
      callback: handleUpdateFileStatusAndRerenderFile,
    },
    {
      eventName: "removeFileFromUploadFileListing",
      callback: handleUpdateUploadFileListing,
    },
    {
      eventName: "removeMultipleFilesFromUploadFileListing",
      callback: handleUpdateUploadFileListing,
    },
    {
      eventName: "updateFileKeyAndId",
      callback: handleUpdateUploadFileListing,
    },
    {
      eventName: "scrollToCurrentUploadFile",
      callback: (action, payload) => {
        const scrollWithActivityUpload = _$("#scrollWithActivityUpload");
        const scrollWithActivityUploadWrapper = _$(
          "#scrollWithActivityUploadWrapper"
        );

        const { file } = payload;

        if (scrollWithActivityUploadWrapper.hasClass("is-hidden")) {
          scrollWithActivityUploadWrapper.show();
        }

        const canScrollUploadList = scrollWithActivityUpload?.el()?.checked;
        if (!canScrollUploadList || !file) {
          return;
        }

        const { id } = file;
        let index = -1;

        const fileList = Object.values(store.fileList);
        fileList.every((file) => {
          if (file.hide) {
            return true;
          }

          index++;

          if (file.id === id) {
            return false;
          }

          return true;
        });

        virtualScrollerList.scrollToIndex(index);
      },
    },
    {
      eventName: "fileUploadingQueueFinished",
      callback: (action, payload) => {
        const { canceled, completedFiles } = payload;

        const allFiles = Object.values(store.fileList);
        const completedUploadFiles = allFiles.filter(
          (file) => file.status !== "init"
        );
        const completedFileList = completedFiles.map((completedFile) => {
          const selectedFile = completedUploadFiles.find(
            (completedUploadFile) => completedUploadFile.id === completedFile.id
          );
          return { ...selectedFile };
        });

        const parentPostUploadConfig = {
          type: "uploadCompleted",
          files: completedFileList.map((file) => ({
            name: file.name,
            uploading_to: file.nameF,
            size: file.size,
            status: file.status,
          })),
        };

        invoke("uploadNotifications", [parentPostUploadConfig]);

        if (!canceled) {
          queueCompleted = true;

          const allUploadedFiles = allFiles.filter(
            (file) => file.status === "init"
          );

          if (allUploadedFiles.length === 0) {
            const redirectToAfterUpload = invoke("getUserCustomizationValue", [
              "redirectToAfterUpload",
              true,
            ]);

            if (redirectToAfterUpload) {
              invoke("redirectPage", [redirectToAfterUpload]);
            }
          }

          const showMessageAfterUpload = invoke("getUserCustomizationValue", [
            "showMessageAfterUpload",
          ]);

          if (showMessageAfterUpload) {
            _$("#uploadCompleteSection").removeClass("is-hidden");
          }
        }

        const scrollWithActivityUploadWrapper = _$(
          "#scrollWithActivityUploadWrapper"
        );
        scrollWithActivityUploadWrapper.addClass("is-hidden");
        // _$("#globalUploads").html("");
        // _$("#globalUploads").addClass("is-hidden");

        const closeModalOnFinishUpload = invoke("getUserCustomizationValue", [
          "upload_hideUploadBarAfterUpload",
        ]);
        const autoRemoveUploadedItemFromList = invoke(
          "getUserCustomizationValue",
          ["autoRemoveUploadedItemFromList"]
        );
        const autoShareUploadedItem = invoke("getUserCustomizationValue", [
          "autoShareUploadedItem",
        ]);
        const autoQuickShareUploadedItem = invoke("getUserCustomizationValue", [
          "autoQuickShareUploadedItem",
        ]);
        const disableAutohideUploadCompleteGrowl = invoke(
          "getUserCustomizationValue",
          ["noTimeoutUploadedNote"]
        );
        const notifyToShareOnUploadComplete = invoke(
          "getUserCustomizationValue",
          ["autoShareUploadedItemNotify"]
        );
        const notifyOnUploadComplete = invoke("getUserCustomizationValue", [
          "showUploadNotification",
        ]);
        const runBatchCompletedCommandAfterUploadQueueFinishes = invoke(
          "getUserCustomizationValue",
          ["runBatchCompletedCommandAfterUploadQueueFinishes"]
        );
        invoke("continueDownload");

        if (notifyOnUploadComplete) {
          const onPermissionGranted = () => {
            new Notification("Upload Completed", {
              body: "All files uploaded.",
            });
          };

          utils.sendBrowserNotification({ onPermissionGranted });
        }

        if (
          notifyToShareOnUploadComplete &&
          (autoShareUploadedItem || autoQuickShareUploadedItem)
        ) {
          const onPermissionGranted = () => {
            new Notification("Alert", {
              icon: `assets/images/favicon-logo.png`,
              body: "Your files are uploaded and ready to share",
            });
          };

          utils.sendBrowserNotification({ onPermissionGranted });
        }

        if (runBatchCompletedCommandAfterUploadQueueFinishes) {
          batchComplete()
            .then(() => {
              invoke("growl", [t("transferAcknowledged"), t("result"), 4000]);
            })
            .catch((err) => {
              invoke("growl", [err, "", 4000, true]);
            });
        }

        const isElectronUploadOnlyApp = invoke("isElectron");
        if (isElectronUploadOnlyApp && !canceled) {
          shareFilesOnQueueFinishedElectron();
        }

        if (autoShareUploadedItem || autoQuickShareUploadedItem) {
          const files = getSharingFiles();
          if (files.filesLength) {
            if (autoQuickShareUploadedItem) {
              invoke("initQuickSharing", [files]);
            } else if (autoShareUploadedItem) {
              invoke("initSharing", [files]);
            }
          }
        }

        // Auto remove item on complete customization
        if (autoRemoveUploadedItemFromList) {
          store.dispatch("removeMultipleFilesFromUploadFileListing", {
            status: "done",
          });
        }

        if (closeModalOnFinishUpload) {
          invoke("closeUploadModal");
        }

        invoke("refreshListing");

        if (canceled) {
          invoke("titleAlert", [` ** ${t(`uploadingCanceled`)} **`, 1000]);
          return;
        }

        invoke("titleAlert", [` ** ${t("uploadCompleted")} **`, 1000]);

        const dontShowUploadQueueCompletedGrowlMessage = invoke(
          "getUserCustomizationValue",
          ["dontShowUploadQueueCompletedGrowlMessage"]
        );

        if (
          !dontShowUploadQueueCompletedGrowlMessage &&
          !runBatchCompletedCommandAfterUploadQueueFinishes
        ) {
          invoke("growl", [
            "",
            t("uploadCompleted"),
            disableAutohideUploadCompleteGrowl ? null : 4000,
            false,
          ]);
        }
      },
    },
    {
      eventName: "enableGlobalUpload",
      callback: () => {
        const currentUploadingFile = uploadingQueue.getCurrentUploadingFile();
        const uploadingFiles = uploadingQueue.getGlobalUploadedFiles();
        const completedFiles = uploadingQueue.getCompletedFiles();

        if (uploadingFiles.length === 0) {
          return;
        }

        const curFile = store.fileList[currentUploadingFile.id];

        if (!curFile) {
          return;
        }

        const globalStartTime = uploadingQueue.getGlobalUploadStartTime();

        const allUploadFiles = Object.values(store.fileList).filter((file) => {
          if (file.hide) return false;
          const status = file.status;
          return (
            status === "init" ||
            status === "queued" ||
            status === "uploading" ||
            status === "paused" ||
            status === "pausing" ||
            status === "done" ||
            status === "canceled" ||
            status === "failed" ||
            status === "canceling" ||
            status === "finalizing" ||
            status === "fileSizeExceededInit"
          );
        });

        const totalElapsedTime = getTotalElapsedUploadTimeInSeconds({
          allUploadFiles,
          currentFile: curFile,
          globalStartTime,
        });

        let totalBytesToUpload = 0;
        let totalBytesUploaded = curFile.uploadedBytes || 0;

        allUploadFiles.forEach((file) => {
          if (!file) return;
          totalBytesToUpload += file.size || 0;
        });

        const completedFilesCount = allUploadFiles.filter(
          (file) => file.status === "done"
        ).length;

        allUploadFiles.forEach((file) => {
          if (file.status === "done") {
            totalBytesUploaded += file.size || 0;
          }
        });

        const { uploadedBytesFormatted, completedPercentage } =
          getProgressBarStatusGlobal({
            uploadedBytes: totalBytesUploaded,
            size: totalBytesToUpload,
          });

        const size = utils.formatBytes(totalBytesToUpload);
        const status = store.fileList[currentUploadingFile.id].status;
        const showCardButtons = getButtonsToShowOnFileCardGlobal(status);

        const formattedElapsedTime = utils.formatTime({
          secs: totalElapsedTime,
          minLabel: "m",
          secondsLabel: "s",
        });

        const averageSpeed =
          totalElapsedTime > 0 ? totalBytesUploaded / totalElapsedTime : 0;
        const formattedAverageSpeed = utils.formatBytes(
          Number.isFinite(averageSpeed) ? averageSpeed : 0
        );

        const remainingBytes = totalBytesToUpload - totalBytesUploaded;
        const timeRemaining =
          averageSpeed > 0 && Number.isFinite(averageSpeed)
            ? remainingBytes / averageSpeed
            : null;

        const formattedTimeRemaining =
          timeRemaining && Number.isFinite(timeRemaining) && timeRemaining > 0
            ? utils.formatTime({
                secs: timeRemaining,
                minLabel: "m",
                secondsLabel: "s",
              })
            : "-";

        _$("#globalUploads").html(
          globalFileCardTemplate({
            name: currentUploadingFile.nameF,
            currentUploadingFileNumber: completedFilesCount + 1,
            totalUploadingFiles: allUploadFiles.length,
            totalBytesToUpload,
            totalBytesUploaded,
            showProgressBar: true,
            remainingText: t("remaining"),
            uploadingText: t("uploading"),
            speedText: t("speed"),
            cancelText: t("cancel"),
            resumeText: t("resume"),
            pauseText: t("pause"),
            pausingText: t("pausing"),
            cancelingText: t("canceling"),
            averageSpeedText: t("averageSpeed"),
            elapsedText: t("elapsed"),
            skipText: t("skip"),
            completedPercentage,
            uploadedBytesFormatted,
            size,
            elapsedTime: formattedElapsedTime,
            timeRemaining: formattedTimeRemaining,
            overAllSpeed: formattedAverageSpeed,
            ...showCardButtons,
          })
        );

        _$("#globalUploads #skip-button").on("click", () => {
          const canceled = window.confirm(
            t("areYouSureYouWantToCancelParticularFileFromUploading", {
              file: currentUploadingFile.nameF,
            })
          );

          if (canceled) {
            uploadingQueue.cancel();
          }
        });

        _$("#globalUploads #cancel-button").on("click", () => {
          if (uploadingQueue.queue.length < 1) return;

          const canceled = window.confirm(
            t("areYouSureYouWantToCancelUploading")
          );

          if (canceled) {
            uploadingQueue.cancel(true);
          }
        });

        _$("#globalUploads #pause-button").on("click", () => {
          uploadingQueue.pausing();
        });

        _$("#globalUploads #resume-pause-button").on("click", () => {
          uploadingQueue.resume();
        });

        _$("#globalUploads").removeClass("is-hidden");

        // Start interval to update time every second
        if (globalUploadTimeUpdateInterval) {
          clearInterval(globalUploadTimeUpdateInterval);
        }
        globalUploadTimeUpdateInterval = setInterval(() => {
          updateGlobalProgressBarTime();
        }, 1000);
      },
    },
    {
      eventName: "updateCurrentFileGlobal",
      callback: (action, payload) => {
        _$("#current-uploading-file-global").text(payload.file.nameF);
      },
    },
    {
      eventName: "disableGlobalUpload",
      callback: () => {
        // Clear the interval when uploads are disabled
        if (globalUploadTimeUpdateInterval) {
          clearInterval(globalUploadTimeUpdateInterval);
          globalUploadTimeUpdateInterval = null;
        }
        _$("#globalUploads").html("");
        _$("#globalUploads").addClass("is-hidden");
      },
    },
    {
      eventName: "updateGlobalUploadTime",
      callback: () => {
        // Use the shared function for consistency
        updateGlobalProgressBarTime();
      },
    },
  ];

  uploadFileActions.forEach((action) => {
    store.subscribe(action.eventName, action.callback);
  });
};

const getButtonsToShowOnFileCardGlobal = (status) => {
  let button = {
    skipButton: true,
    cancelButton: true,
  };

  const cardButtons = {
    uploading: {
      pauseButton: true,
    },
    pausing: {
      pausingButton: true,
    },
    canceling: {
      skipButton: false,
      cancelButton: false,
      cancelingButton: true,
    },
    paused: {
      resumePauseButton: true,
    },
  };

  const dynamicButtons = cardButtons[status] || { pauseButton: true };
  return { ...button, ...dynamicButtons };
};

const getProgressBarStatusGlobal = (file) => {
  const { uploadedBytes = 0, size } = file;
  let progressBarStatus = {};

  const updatedValue = parseInt(uploadedBytes);

  progressBarStatus.uploadedBytesFormatted = utils.formatBytes(updatedValue);
  progressBarStatus.uploadedBytes = updatedValue;

  const percent = updatedValue / size;

  progressBarStatus.completedPercentage = `${Math.floor(
    Math.min((isNaN(percent) ? 0 : percent) * 100, 99)
  )} %`;

  return progressBarStatus;
};

const updateGlobalProgressBar = (size) => {
  const currentUploadingFile = uploadingQueue.getCurrentUploadingFile();

  const allUploadFiles = Object.values(store.fileList).filter((file) => {
    if (file.hide) return false;
    const status = file.status;
    return (
      status === "init" ||
      status === "queued" ||
      status === "uploading" ||
      status === "paused" ||
      status === "pausing" ||
      status === "done" ||
      status === "canceled" ||
      status === "failed" ||
      status === "canceling" ||
      status === "finalizing" ||
      status === "fileSizeExceededInit"
    );
  });

  let totalBytesToUpload = 0;
  let totalBytesUploaded = 0;

  // Get current uploading file's uploaded bytes from store
  if (currentUploadingFile) {
    const curFile = store.fileList[currentUploadingFile.id];
    if (curFile) {
      totalBytesUploaded = curFile.uploadedBytes || 0;
    }
  }

  allUploadFiles.forEach((file) => {
    if (!file) return;
    totalBytesToUpload += file.size || 0;
  });

  allUploadFiles.forEach((file) => {
    if (file.status === "done") {
      totalBytesUploaded += file.size || 0;
    }
  });

  fileProgressStatus.updateUploadFileProgressBar({
    fileId: "globalUploads",
    size: totalBytesUploaded,
    maxSize: totalBytesToUpload,
  });
};

const addFileThroughGlobalButton = (files) => {
  if (uploadingQueue.queue.length > 0 && isMaxFileErrorActive) {
    invoke("growl", [
      t("maxNumberOfFilesExceeded"),
      t("maxFileAllowedTouploadExceeded", { maxFilesAllowedInQueue }),
      4000,
      true,
    ]);
    return;
  }

  const filesToUpload = convertFilesObjectToList(files);
  addFilesToQueue(filesToUpload);
};

// Function to copy debug information to clipboard
const copyDebugInfoToClipboard = async (fileId) => {
  try {
    // Get the file data from store
    const fileData = store.fileList[fileId];
    if (!fileData) {
      console.warn(`File data not found for ID: ${fileId}`);
      return;
    }

    // Get the current upload instance if it exists
    const currentUploadInstance =
      uploadingQueue.getCurrentUploadingFileInstance();

    let debugInfo = `=== UPLOAD DEBUG: ${fileData.nameF} ===\n`;
    debugInfo += `File ID: ${fileId}\n`;
    debugInfo += `Size: ${fileData.sizeF}\n`;
    debugInfo += `Status: ${fileData.status}\n`;
    debugInfo += `Upload Type: ${fileData.uploadType || "Normal"}\n`;
    debugInfo += `Time: ${new Date().toLocaleString()}\n\n`;

    // Add file-specific debug information
    if (fileData.uploadingError) {
      debugInfo += `=== UPLOAD ERROR ===\n`;
      debugInfo += `${fileData.uploadingError}\n\n`;
    }

    if (fileData.time) {
      debugInfo += `=== UPLOAD STATS ===\n`;
      debugInfo += `Upload Time: ${(fileData.time / 1000).toFixed(
        2
      )} seconds\n`;
      if (fileData.averageUploadingSpeed) {
        debugInfo += `Average Speed: ${fileData.averageUploadingSpeed}\n`;
      }
      debugInfo += `\n`;
    }

    // Add current upload instance debug info if this is the current file
    if (
      currentUploadInstance &&
      currentUploadInstance.streamingFileInfo?.id === fileId
    ) {
      try {
        // Use the same formatDebugInfo method as the debug panel for consistency
        const wsDebugInfo = currentUploadInstance.formatDebugInfo();
        debugInfo += wsDebugInfo;
      } catch (error) {
        debugInfo += `=== WEBSOCKET DEBUG ===\n`;
        debugInfo += `Error getting debug info: ${error.message}\n`;
      }
    } else {
      debugInfo += `=== WEBSOCKET DEBUG ===\n`;
      debugInfo += `File not currently being uploaded via WebSocket\n`;
      debugInfo += `This means the file is either:\n`;
      debugInfo += `- Completed successfully\n`;
      debugInfo += `- Failed and stopped\n`;
      debugInfo += `- Waiting in queue\n`;
      debugInfo += `- Using normal upload (not WebSocket)\n`;
    }

    // Copy to clipboard
    await navigator.clipboard.writeText(debugInfo);

    // Show success message
    invoke("growl", [
      "Debug Info Copied",
      `Debug information for "${fileData.nameF}" has been copied to clipboard`,
      3000,
      false,
    ]);

    console.log("Debug information copied to clipboard:", debugInfo);
  } catch (error) {
    console.error("Error copying debug info to clipboard:", error);
    invoke("growl", [
      "Error",
      "Failed to copy debug information to clipboard",
      3000,
      true,
    ]);
  }
};

// Function to add Alt+Click event listeners to upload file cards
const addAltClickListeners = () => {
  // Remove existing listeners to avoid duplicates
  document.removeEventListener("click", handleAltClick);

  // Add new listener
  document.addEventListener("click", handleAltClick);
};

// Handle Alt+Click on upload file cards
const handleAltClick = (event) => {
  // Check if Alt key is pressed
  if (!event.altKey) return;

  // Find the closest upload file card
  const uploadCard = event.target.closest(".upload-file-card");
  if (!uploadCard) return;

  // Prevent default behavior
  event.preventDefault();
  event.stopPropagation();

  // Get file ID from data attribute
  const fileId = uploadCard.getAttribute("data-file-id");
  if (!fileId) {
    console.warn("No file ID found on upload card");
    return;
  }

  // Copy debug info to clipboard
  copyDebugInfoToClipboard(fileId);
};

//On DOM Ready
_$("body").ready(async () => {
  const isElectronUploadOnlyApp = invoke("isElectron");

  //initialize theme
  const theme = invoke("getCurrentTheme");
  _$("html").attr("data-theme", theme);

  const newLocale = invoke("getCurrentLanguage");
  setLocale({ newLocale });

  // subscribe events for store
  subscribe();
  // upload modal header button events
  uploadHeaderButtonsEvents();
  // upload drag and drop events
  uploadDragAndDropEvents();
  // initializing dropdown instance
  new Dropdown({});

  // Virtual Scroller For List View
  virtualScrollerList = new VirtualScroller({
    width: "100%",
    itemHeight: isElectronUploadOnlyApp ? 100 : 80,
    maxRowsToShow: 10,
    topOffset: 0,
  });

  const updateShareUploadedButtonVisibility = () => {
    const disableShareForUploadedItem = invoke("getUserCustomizationValue", [
      "disableShareForUploadedItem",
    ]);
    const currentDirPrivs = invoke("currentDirPrivs");
    const hasSharePermission = currentDirPrivs?.includes("(share)");

    const shareButtonParent = _$("#shareUploadedButtonUploadModalParent").el();
    if (!shareButtonParent) return;

    if (disableShareForUploadedItem || !hasSharePermission) {
      _$("#shareUploadedButtonUploadModalParent").addClass("is-hidden");
    } else {
      _$("#shareUploadedButtonUploadModalParent").removeClass("is-hidden");
    }
  };
  updateShareUploadedButtonVisibility();

  const commonUploadForm = invoke("commonUploadForm");

  if (!commonUploadForm?.formDetails) {
    _$("#commonUploadFormButton").remove();
  } else {
    _$("#commonUploadFormButton").removeClass("is-hidden");
  }

  _$("#uploadCompleteSection .close-button").on("click", () => {
    _$("#uploadCompleteSection").addClass("is-hidden");
  });

  _$("#uploadCompleteSection").on("click", (e) => {
    const clickedOnUploadCompleteChip = _$(
      "#uploadCompleteSection .upload-complete-chip"
    )
      .el()
      .contains(e.target);
    if (clickedOnUploadCompleteChip) {
      return;
    }

    _$("#uploadCompleteSection").addClass("is-hidden");
  });

  const onHostMessage = (event) => {
    if (event.origin !== window.location.origin) return;
    if (event.source !== window.parent) return;
    const data = event.data;
    if (!data || typeof data !== "object") return;
    const { key, value } = data;
    switch (key) {
      case "theme":
        _$("html").attr("data-theme", value);
        break;
      case "language":
        setLocale(value);
        break;
      case "open":
        window.init_href_path = value;
        if (Object.keys(store.fileList).length === 0)
          _$("#addFilesButtonUploadModal").el().click();
        break;
      case "currentDirectoryInfoUpdated":
        updateShareUploadedButtonVisibility();
        break;
      case "continueUpload":
        uploadingQueue.continueUpload();
        break;
      case "refreshUploadList":
        reCheckFileQuota();
        break;
      case "filesDeleted":
        clearServerExistsAfterDelete(value);
        break;
      case "addFilesToQueue":
        addFileThroughGlobalButton(value);
        break;
      case "overrideFontFamily":
        // NOTE: element.style.setProperty() for CSS custom properties is CSP-compliant.
        // CSSOM operations like setProperty() are allowed by CSP policy style-src 'self'.
        // This is the recommended approach for dynamic CSS variables like font family theming.
        document.documentElement.style.setProperty("--font-family", value);
        break;
      case "applyTemporaryTheme":
        if (value && typeof value === "object") {
          utils.applyCSSThemeVariables(value);
        }
        break;
      case "crushdropUploadPath":
        if (typeof value === "string") {
          syncCrushdropPathFromMessageOrEvent(value);
        }
        break;
      case "uploadModalResize":
        virtualScrollerList.resize();
        break;
      default:
        break;
    }
  };

  window.addEventListener("message", onHostMessage);

  window.addEventListener("crushdrop-upload-path", (e) => {
    const p = e.detail && e.detail.path;
    if (typeof p === "string") {
      syncCrushdropPathFromMessageOrEvent(p);
    }
  });

  try {
    if (window.parent && window.parent !== window) {
      window.parent.addEventListener("crushdrop-upload-path", (e) => {
        const p = e.detail && e.detail.path;
        if (typeof p === "string") {
          syncCrushdropPathFromMessageOrEvent(p);
        }
      });
    }
  } catch (e) {}

  // Add Alt+Click event listeners to upload file cards
  addAltClickListeners();
});
